<template>

  <div v-show="isActive" class="mobile-payment-screen">

    <!-- Ürün Birleştir Modal -->

    <vs-popup id="mergeProductModal" :active.sync="isMergeModalOpen" title="Ürün Birleştir">

      <vs-row vs-type="flex" vs-w="12" vs-justify="center">

        <!-- Başlık ve Mevcut Tutar -->

        <vs-col vs-type="flex" vs-w="12" vs-justify="center" class="mb-4">

          <div

            class="bg-white text-primary bold py-3 px-5"

            style="

              border-radius: 10px;

              border: 1px solid #e1e1e1;

              box-shadow: 0px 3px 6px #00000029;

              font-size: 1.2rem;

            "

          >

            Yeni Birleşik Ürün Fiyatı Giriniz

          </div>

        </vs-col>



        <!-- Mevcut Toplam -->

        <vs-col vs-type="flex" vs-w="12" vs-justify="center" class="mb-4">

          <div

            class="bg-secondary text-primary bold py-2 px-4"

            style="

              border-radius: 10px;

              border: 1px solid #e1e1e1;

              font-size: 1rem;

            "

          >

            Mevcut Toplam: {{ $toCurrency(selectedGroupsPrice) }}

          </div>

        </vs-col>



        <!-- Ödenen Tutar (varsa) -->

        <vs-col v-if="totalPayedPriceForMerge > 0" vs-type="flex" vs-w="12" vs-justify="center" class="mb-4">

          <div

            class="bg-warning text-white bold py-2 px-4"

            style="

              border-radius: 10px;

              border: 1px solid #e1e1e1;

              font-size: 1rem;

            "

          >

            Ödenen Tutar: {{ $toCurrency(totalPayedPriceForMerge) }}

          </div>

        </vs-col>



        <!-- Fiyat Input -->

        <vs-col vs-type="flex" vs-w="10" vs-justify="center" class="mb-4">

          <input

            autofocus="true"

            id="txtMergePrice"

            ref="txtMergePrice"

            name="mergePrice"

            autocomplete="off"

            size="large"

            type="number"

            step="0.01"

            min="0"

            v-model="newMergePrice"

            class="bold w-full price-input"

            placeholder="0.00"

          />

        </vs-col>



        <!-- Onayla ve İptal Butonları -->

        <vs-col vs-type="flex" vs-w="8" vs-justify="center" class="mt-4">

          <vs-row vs-type="flex" vs-w="12">

            <vs-col vs-type="flex" vs-w="6" class="pr-2">

              <vs-button

                @click="confirmMergeFromModal"

                :disabled="!newMergePrice || parseFloat(newMergePrice) <= 0 || parseFloat(newMergePrice) < totalPayedPriceForMerge"

                color="transparent"

                class="bg-success text-white w-full bold py-4"

                style="font-size: 1.3rem; min-height: 55px;"

              >

                Onayla

              </vs-button>

            </vs-col>

            <vs-col vs-type="flex" vs-w="6" class="pl-2">

              <vs-button

                @click="cancelMerge"

                color="transparent"

                class="bg-danger text-white w-full bold py-4"

                style="font-size: 1.3rem; min-height: 55px;"

              >

                İptal

              </vs-button>

            </vs-col>

          </vs-row>

        </vs-col>

      </vs-row>

    </vs-popup>

    <custom-loading-component />

    <qr-reader

      ref="qrReader"

      @reduceSuccess="commitPay"

      @success="commitQrCode"

    />

    <cari-select

      ref="cariSelect"

      @cari-selected="handleCariSelected"

    />

    <calc

      v-if="isPosEnabled"

      ref="calculatorPage"

      @closeEvent="closeCalculatorPage"

      @doPay="doPay"

      @setIsPieced="setIsPieced"

      :totalPrice="separatePaymentPrice"

      :currentDate="currentDate"

      :currentTime="currentTime"

    />

    <calc

      v-if="!isPosEnabled"

      ref="calculatorPage"

      @closeEvent="closeCalculatorPage"

      @doPay="doPayWithoutPos"

      :totalPrice="separatePaymentPrice"

      :currentDate="currentDate"

      :currentTime="currentTime"

    />



    <!-- Header -->

    <div class="payment-header">

      <div class="header-title">

        <i class="feather icon-credit-card"></i>

        <template v-if="currentCart">
          <span>Ödeme Ekranı - {{ tableName }}</span>
        </template>

      </div>

      <button class="close-button" @click="closePaymentScreen">

        <i class="feather icon-x"></i>

      </button>

    </div>



    <!-- Personal Info -->

    <div class="personal-info" v-if="activePersonel">

      <div class="personal-name">

        <span class="info-label">Personal:</span>

        <span class="info-value">{{ activePersonel ? activePersonel.name : "" }}</span>

      </div>

      <div class="date-time">

        <span class="info-value">{{ currentDate }}</span>

        <span class="info-value ml-1">{{ currentTime }}</span>

      </div>

    </div>



    <!-- Products List -->

    <div class="products-container">

      <div class="products-list">

        <table class="products-table">

          <thead>

            <tr>

              <th class="check-col" style="width: 30px; text-align: center; padding: 0;">
                <vs-checkbox class="select-all-checkbox" v-model="isAllSelected" style="margin: 0 auto; display: inline-flex; justify-content: center;"></vs-checkbox>
              </th>

              <th class="product-col" style="width: 100%;">Ürün</th>

              <th v-if="hasTimeProducts" class="time-btn-col" style="width: 85px; text-align: center;">Süre Bilgi</th>

              <th class="price-col">Fiyat</th>

            </tr>

          </thead>

          <tbody>

            <tr
              v-for="(tr, indextr) in sortedPaymentGroups"
              :key="indextr"
              :class="{ 'selected-row': selectedPaymentGroup.includes(tr), 'alternate-row': indextr % 2 != 0 }"
            >

              <td class="check-col" style="width: 30px; text-align: center; padding: 0;">
                <vs-checkbox v-model="selectedPaymentGroup" :vs-value="tr" style="margin: 0 auto; display: inline-flex; justify-content: center;"></vs-checkbox>
              </td>

              <td class="product-col">
                <div style="display: flex; align-items: center; gap: 12px; width: 100%;">
                  <!-- Ürün Bilgileri -->
                  <div style="flex: 1; min-width: 0;">
                    <div v-for="entry in tr.entries" :key="entry.id" class="product-entry">
                  <div class="product-name" style="font-size: 0.85rem; line-height: 1.2; font-weight: 500; word-break: break-word;">
                    {{ entry.productName + (entry.quantity > 1 ? " - x" + entry.quantity : "") }}
                  </div>
                  <div v-if="(entry.recipe && (entry.recipe.steps || entry.recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.Steps || entry.Recipe.recipeSteps || entry.Recipe.RecipeSteps)) || (entry.recipeSteps || entry.RecipeSteps || entry.steps || entry.Steps)">
                    <p
                      v-for="(rawmaterial, rawMaterialIndex) in (entry.recipe && (entry.recipe.steps || entry.recipe.Steps || entry.recipe.recipeSteps || entry.recipe.RecipeSteps)) || (entry.Recipe && (entry.Recipe.steps || entry.Recipe.Steps || entry.Recipe.recipeSteps || entry.Recipe.RecipeSteps)) || entry.recipeSteps || entry.RecipeSteps || entry.steps || entry.Steps || []"
                      v-if="rawmaterial && (rawmaterial.isRemoved || rawmaterial.IsRemoved || rawmaterial.is_removed || rawmaterial.is_Removed || (rawmaterial.selected && !rawmaterial.isDefault) || (rawmaterial.Selected && !rawmaterial.IsDefault) || (rawmaterial.isSelected && !rawmaterial.isDefault) || (rawmaterial.selected && !rawmaterial.IsDefault) || (rawmaterial.Selected && !rawmaterial.isDefault) || rawmaterial.isRemoved === true || rawmaterial.IsRemoved === true || rawmaterial.is_removed === true || (rawmaterial.selected === true && rawmaterial.isDefault === false))"
                      :key="rawMaterialIndex"
                      :class="{'line-through': rawmaterial.isRemoved || rawmaterial.IsRemoved || rawmaterial.is_removed || rawmaterial.is_Removed}"
                      class="text-primary product-extra tr-text-child text-left"
                    >
                      {{ (rawmaterial.name || rawmaterial.Name || (rawmaterial.rawMaterial && rawmaterial.rawMaterial.name) || (rawmaterial.rawMaterial && rawmaterial.rawMaterial.Name) || (rawmaterial.rawmaterial && rawmaterial.rawmaterial.name) || (rawmaterial.rawmaterial && rawmaterial.rawmaterial.Name) || '').trim() }}
                    </p>
                  </div>

                  <div class="mobile-extras">

                    <template v-for="extra in entry.extras">

                      <div v-if="extra.quantity > 0 && extra.variants.length == 0" :key="extra.id" class="product-extra">

                        x{{ extra.quantity }} / {{ extra.name }}

                      </div>

                      <div

                        v-else-if="extra.variants.length > 0"

                        v-for="seletedVariantExtra in returnSelectedExtraVariant(extra)"

                        :key="seletedVariantExtra"

                        class="product-extra"

                      >

                        {{ seletedVariantExtra }}

                      </div>

                    </template>

                  </div>

                </div>

                  </div>
                </div>
              </td>

              <!-- v146: Süreli ürün kontrol alanı checkbox yanından Ürün-Fiyat arasına taşındı ve td içine alındı -->
              <td v-if="hasTimeProducts" class="time-col" style="width: 85px; text-align: center;">
                <div v-if="tr.entries.find(entry => entry.isTime)" class="time-control-buttons" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                  <!-- v138.3: Butonlar tamamen kaldırıldı, sadece bilgi gösteriliyor -->
                  <div class="time-display" style="background: rgba(var(--vs-primary), 0.05); padding: 2px 6px; border-radius: 4px; border: 1px solid rgba(var(--vs-primary), 0.1);">
                    <p class="text-xs text-center text-primary font-bold" style="font-size: 0.75rem; white-space: nowrap; margin: 0;">
                      {{ getDisplayTimeRange(tr.entries.find(entry => entry.isTime)) }}
                    </p>
                  </div>
                </div>
              </td>

              <td class="price-col">

                <div class="price-display">

                  <span

                    v-if="tr.payedPrice > 0 && tr.payedPrice != tr.totalPrice"

                    class="original-price"

                  >

                    {{ $toCurrency(tr.totalPrice) }}

                  </span>

                  <span

                    class="current-price"

                    :class="{

                      'paid-price': $isRowPaid(tr),

                      'clickable-price': !$isRowPaid(tr) && $isAdmin()

                    }"

                    @click="openPriceEditDialog(tr)"

                  >

                    {{ !$isRowPaid(tr)
                        ? (tr.entries.some(entry => entry.isTime && entry.isRunning)
                           ? $toCurrency(calculateCurrentPrice(tr))
                           : $toCurrency(tr.totalPrice - tr.payedPrice))
                        : "Ödendi" }}

                  </span>

                </div>

              </td>

            </tr>

          </tbody>

        </table>

      </div>

    </div>



    <!-- Total Price Bar -->

    <!-- Sticky Bottom Actions Area (v118.V29: Fixed position fix) -->
    <div class="sticky-payment-footer">
      
      <!-- Financial Summary Card -->
      <div class="payment-summary-card">
        <div class="summary-line">
          <span class="label">Ara Toplam:</span>
          <span class="value">{{ $toCurrency(totalOriginPrice) }}</span>
        </div>
        
        <div v-if="totalDiscountPrice > 0" class="summary-line discount-line">
          <span class="label">İndirim:</span>
          <span class="value">-{{ $toCurrency(totalDiscountPrice) }}</span>
        </div>

        <div v-if="(totalOriginPrice - totalDiscountPrice) - totalPrice > 0" class="summary-line paid-line">
          <span class="label">Ödenen:</span>
          <span class="value">{{ $toCurrency((totalOriginPrice - totalDiscountPrice) - totalPrice) }}</span>
        </div>

        <div class="summary-divider"></div>

        <div class="summary-line total-line">
          <span class="label">KALAN TUTAR:</span>
          <span class="value kalan-value">{{ $toCurrency(totalPrice) }}</span>
        </div>

        <div class="selected-badge" v-if="selectedGroupsPrice > 0">
          <i class="feather icon-check-square"></i>
          <span>Seçilen: {{ $toCurrency(selectedGroupsPrice) }}</span>
        </div>
      </div>

      <!-- Payment History Dropdown -->
      <div v-if="showPaymentHistory && orderPayments.length > 0" class="payment-history">
        <div v-for="log in orderPayments" :key="log.id" class="payment-log">
          {{ $toCurrency(log.price) }} {{ log.paymentMethod.name }}
          <span v-if="log.paymentMethod.id == 4 && log.unit == '%'" class="ml-1">(%{{ log.value }})</span>
        </div>
      </div>

      <!-- Print option checkbox -->
      <div class="print-option">
        <label class="checkbox-label">
          <input type="checkbox" v-model="isPrintOrders">
          <span>Fiş Yazdırılsın</span>
        </label>

        <div class="mobile-copy-wrap">
          <span class="mobile-copy-label">Kopya</span>
          <input type="number" v-model.number="printCopyCount" min="1" class="copy-count-input" />
        </div>
        <button class="print-button" @click="printBill" :disabled="isPrinting">
          <i v-if="!isPrinting" class="feather icon-printer"></i>
          <i v-if="isPrinting" class="feather icon-loader rotating"></i>
          <span>{{ isPrinting ? 'Yazdırılıyor...' : 'Yazdır' }}</span>
        </button>
      </div>

      <!-- Payment Options Area -->
      <div class="payment-options">
        <div class="payment-type-selector">
          <select-payment-type
            ref="selectPaymentType"
            :dontCloseCalc="false"
            :totalPrice="totalPrice"
            :currentDate="currentDate"
            :currentTime="currentTime"
            :isPaymentBlocked="hasRunningTimeProducts"
            :hasDiscount="totalDiscountPrice > 0"
            :canResetDiscount="totalPaidAmount == 0"
            @open-discount="openDiscountModal"
            @stop-all-timers="stopAllRunningTimeProducts"
            @reset-discount="resetDiscount"
          />
        </div>

        <!-- Connection Error Banner -->
        <div v-if="isPosEnabled && isPosConnectionError" class="mb-2 mt-2 w-full text-center py-2 px-4 bg-danger text-white bold" style="border-radius: 8px; box-shadow: 0px 3px 6px rgba(0,0,0,0.16); font-weight: bold;">
          <i class="feather icon-wifi-off mr-2"></i>
          POS Bridge Bağlantısı Koptu! Lütfen Servisi Kontrol Edin.
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <button
            v-if="$isAdmin()"
            class="action-button clear-button"
            :disabled="!selectedPaymentGroup.length"
            @click="ClearCart"
          >
            <i class="feather icon-trash"></i>
            <span>Sil</span>
          </button>

          <button
            v-if="selectedPaymentGroup.length == 1 && selectedPaymentGroup[0].entries[0].quantity > 1"
            class="action-button split-button"
            @click="breakToRow"
          >
            <i class="feather icon-scissors"></i>
            <span>Parçala</span>
          </button>

          <button
            v-if="!isCommitable && isPosEnabled"
            class="action-button pay-button"
            :disabled="hasRunningTimeProducts || isTransaction || (isPosConnectionError && selectedPaymentMethod && (selectedPaymentMethod.id == VUE_APP_CASH_PAYMENT_ID || selectedPaymentMethod.id == VUE_APP_CREDIT_PAYMENT_ID))"
            @click="doPay(selectedPaymentGroup.length > 0 ? selectedGroupsPrice : totalPrice, false)"
          >
            <i class="feather icon-check-circle"></i>
            <span>
              {{
                          posType == this.VUE_APP_POS_CLOUD && !manuelPayment &&
                          (selectedPaymentMethod && (selectedPaymentMethod.id == this.VUE_APP_CASH_PAYMENT_ID || selectedPaymentMethod.id == this.VUE_APP_CREDIT_PAYMENT_ID))
                          ? "Cihaza gönder"
                          : (selectedPaymentMethod ? selectedPaymentMethod.name + " ile Öde" : null)
                        }}
            </span>
          </button>

          <button
            v-if="!isCommitable && !isPosEnabled"
            class="action-button pay-button"
            :disabled="hasRunningTimeProducts"
            @click="doPayWithoutPos(selectedPaymentGroup.length > 0 ? selectedGroupsPrice : totalPrice, false)"
          >
            <i class="feather icon-check-circle"></i>
            <span>
              {{ selectedPaymentMethod ? selectedPaymentMethod.name : "" }} ile Öde
            </span>
          </button>

          <button
            v-if="isCommitable"
            class="action-button complete-button"
            :disabled="isTransaction"
            @click="createCommitModel"
          >
            <i class="feather icon-check"></i>
            <span>Sepeti Bitir</span>
          </button>

          <button
            class="action-button amount-split-button"
            :disabled="totalPrice == 0 || hasRunningTimeProducts"
            @click.stop="seperatePayment"
          >
            <i class="feather icon-divide-square"></i>
            <span>Tutar Böl</span>
          </button>
        </div>
      </div>
    </div>



    <vs-popup id="receiptPreviewModal" :active.sync="isReceiptPreviewActive" title="Fiş Önizleme" class="receipt-preview-popup" fullscreen>
      <div class="preview-container">
        <div class="preview-header">
          <vs-button @click="isReceiptPreviewActive = false" color="#1e1e1e" type="border" icon-pack="feather" icon="icon-arrow-left">Geri</vs-button>
          <vs-button @click="printFromPreview" color="success" type="filled" icon-pack="feather" icon="icon-printer">Yazdır</vs-button>
        </div>
        <div class="preview-content">
          <printer
            ref="printer"
            printerId="printerMobilePreview"
            :printCopyCount="printCopyCount"
            :orderEntries="snapshotBillEntries.length > 0 ? snapshotBillEntries : orderBillEntries"
            :totalPrice="snapshotTotalPaidAmount !== null ? snapshotTotalPaidAmount : totalPaidAmount"
            :totalOriginPrice="snapshotTotalOriginPrice || totalOriginPrice"
            :totalDiscountPrice="snapshotTotalDiscountPrice || totalDiscountPrice"
            :currentDateTime="currentDate + ' ' + currentTime"
            :activePersonal="activePersonel ? activePersonel.name : ''"
            :billNo="orderBillNo"
            :tableName="snapshotTableName || tableName"
            :branchName="$store.state.AppActiveUser.branch.name"
            :connection="connection"
            :orderPayments="(snapshotOrderPayments && snapshotOrderPayments.length > 0) ? snapshotOrderPayments : (currentCart && currentCart.orderPayments ? currentCart.orderPayments : (cart && cart.orderPayments ? cart.orderPayments : []))"
          />
        </div>
      </div>
    </vs-popup>



    <discount

      ref="discount"

      @appendDiscount="appendDiscount"

      :priceToDiscount="selectedPaymentGroup.length > 0 ? selectedGroupsPrice : totalPrice"

      :currentDate="currentDate"

      :currentTime="currentTime"

      class="mobile-friendly-popup"

    />



    <!-- Fiyat Düzenleme Popup -->

    <vs-popup title="Fiyat Düzenle" :active.sync="priceEditPopupActive" class="price-edit-popup">

      <div class="price-edit-content">

        <p class="product-name">

          Ürün: <strong>{{ selectedPaymentGroupForEdit ? selectedPaymentGroupForEdit.entries[0].productName : '' }}</strong>

        </p>



        <div class="price-field current-price-field">

          <label>Mevcut Fiyat:</label>

          <p class="price-value">{{ selectedPaymentGroupForEdit ? $toCurrency(selectedPaymentGroupForEdit.totalPrice - selectedPaymentGroupForEdit.payedPrice) : '' }}</p>

        </div>



        <div class="price-field new-price-field">

          <label>Yeni Fiyat:</label>

          <vs-input

            type="number"

            v-model="newPrice"

            class="w-full"

            step="0.01"

            min="0"

          />

        </div>



        <div class="popup-actions">

          <vs-button color="danger" class="mr-3" @click="priceEditPopupActive = false">

            İptal

          </vs-button>

          <vs-button color="primary" @click="updatePrice">

            Kaydet

          </vs-button>

        </div>

      </div>

    </vs-popup>

    <vs-popup :active.sync="isDescriptionPromptActive" title="Açıklama Gerekli" class="description-prompt-popup">
      <div class="p-4">
        <p class="mb-4 bold text-primary">{{ descriptionPromptText }}</p>
        <vs-textarea v-model="pendingDescription" label="İşlem Açıklaması (Zorunlu)" class="w-full"
          placeholder="Lütfen bir açıklama giriniz..." />
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
          <vs-button @click="cancelDescriptionPrompt" color="danger" type="flat" class="mr-2">Vazgeç</vs-button>
          <vs-button @click="confirmDescriptionPrompt" color="success" :disabled="!pendingDescription || pendingDescription.trim() === ''">Onayla</vs-button>
        </vs-row>
      </div>
    </vs-popup>

  </div>

</template>



<script>

import Discount from "./Discount";

import Printer from "./Printer.vue";

import Calc from "./Calc.vue";

import CustomLoadingComponent from "@/views/pages/customLoadingComponent";

import QrReader from "./QrReader.vue";

import CariSelect from "./CariSelect.vue";

import { uuid } from "vue-uuid";

import { completePayment, addDiscountLog } from "@/api/SelfService";

import SelectPaymentType from "./SelectPaymentType.vue";

import { FindAvailableCampaigns } from "@/api/Campaign.js";

import { getPosSettings } from "@/api/AppSettings";

import {
  setBranchCart,
  removeToCartIds,
  getCarts,
  reserveTable,
  unReserveTable,
  breakToRow,
  getOrderEntries,
  getCartsByTableId,
  triggerKitchenPrintBySID
} from "@/api/Cart";

import { getAllKitchen } from "@/api/Kitchen";

import { SendOrder } from "@/api/PavoCloud";

export default {

  props: {
    currentTime: {
      type: String,
      required: true,
    },
    currentDate: {
      type: String,
      required: true,
    },
    isTableMode: {
      type: Boolean,
      required: true,
    },
    editOrderMode: {
      type: Boolean,
      required: false,
    },
    tableName: {
      type: String,
      required: false,
    },
    connection: {
      type: Object,
      required: false,
      default: null
    }
  },

  components: {

    CustomLoadingComponent,

    Calc,

    SelectPaymentType,

    Printer,

    Discount,

    QrReader,

    CariSelect,

  },

  data() {

    return {

      cloneCurrentCart: [],

      selectedGift: null,

      isPosEnabled: false,

      isPrintOrders: true,
      printCopyCount: 1,


      isTransaction: false,

      showPaymentHistory: false,

      isCommitable: false,

      selectedPaymentGroup: [],

      isActive: false,

      orderPayments: [],

      paymentGroups: [],

      separatePaymentPrice: 0,

      paymentDiscount: {},

      discounts: [],

      ids: [],

      isPieced: false,

      posType: 0,

      orderBillNo: 0,

      isMobile: true,

      posData:{},

      VUE_APP_POS_CLOUD: parseInt(process.env.VUE_APP_POS_CLOUD),
      localMergedIds: [],
      manuelPayment: false,

      VUE_APP_CASH_PAYMENT_ID: parseInt(process.env.VUE_APP_CASH_PAYMENT_ID),

      VUE_APP_CREDIT_PAYMENT_ID: parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID),

      selectedCari: null,

      // Fiyat düzenleme özellikleri

      priceEditPopupActive: false,
      currentTime: new Date(),
      timerInterval: null,

      selectedPaymentGroupForEdit: null,

      newPrice: 0,

      // Loading states

      isPrinting: false,

      // Merge modal data

      isMergeModalOpen: false,

      isCalculatorPageActive: false,
      newMergePrice: "",

      selectedGroupsForMerge: [],

      totalPayedPriceForMerge: 0,

      isDescriptionPromptActive: false,
      descriptionPromptText: "",
      pendingDescription: "",
      snapshotBillEntries: [],
      snapshotTableName: "",
      snapshotTotalOriginPrice: null,
      snapshotTotalDiscountPrice: null,
      snapshotTotalPrice: null,
      snapshotTotalPaidAmount: null,
      snapshotOrderPayments: null,
      submissionId: null,
      localBranchTableUId: null,
      localBranchId: null,
      isReceiptPreviewActive: false,
      kitchens: [],
      isTimerActionInProgress: false,
      isPosConnectionError: false,
      posConnectionInterval: null
    };

  },

  watch: {

    selectedPaymentGroup(newVal, oldVal) {

      if (newVal.length > 0) {

        let lastItem = newVal[newVal.length - 1];

        if (lastItem.totalPrice > 0 && lastItem.totalPrice == lastItem.payedPrice) {
          this.selectedPaymentGroup = oldVal;
        }

      }

    },

    printCopyCount(newVal) {
      localStorage.setItem("printCopyCount", newVal);
    },
    isPrintOrders(val) {
      localStorage.setItem("isPrintOrders", val);
    },


    isActive(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
        this.checkPosDevice().then(() => {
          this.startPosConnectionTimer();
        });
        this.initValues();
        this.initGifts();
        this.loadKitchens();

        const sessionPaymentMethods = this.$store.getters["selfservice/getPaymentMethods"];
        if (sessionPaymentMethods && sessionPaymentMethods.length > 0) {
          const creditId = process.env.VUE_APP_CREDIT_PAYMENT_ID ? parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID) : 2;
          const creditCardMethod = sessionPaymentMethods.find(m => m.id == creditId);
          if (creditCardMethod) {
            this.$store.dispatch("selfservice/setSelectedPaymentMethod", creditCardMethod);
          } else {
            this.$store.dispatch("selfservice/setSelectedPaymentMethod", sessionPaymentMethods[0]);
          }
        }

        if(this.totalPrice == 0) {

          this.isCommitable = true;

        }

      } else {
        this.stopPosConnectionTimer();
        this.isPosConnectionError = false;

        document.body.style.overflow = '';

        this.selectedPaymentGroup = [];

        this.paymentGroups = [];

        this.orderPayments = [];
        this.submissionId = null;
      }

    },

    totalPrice: function (val) {
      console.log("totalPrice mobile changed:", val, "isTransaction:", this.isTransaction, "isLoading:", this.isLoading);

      if (val == 0 && this.isActive == true && !this.isTransaction && !this.isLoading) {
        if (this.currentCart.cartEntries && this.currentCart.cartEntries.length > 0) {
          console.log("Setting isCommitable to true");
          this.isCommitable = true;
          this.createCommitModel();
        } else {
          // Sepet boşsa (başka terminalden kapatılmışsa) popup'ı kapat
          console.log("Cart is empty (mobile), closing popup");
          this.isActive = false;
        }
      } else {
        this.isCommitable = false;
      }
    },

    selectedPaymentMethod(val) {
      if (val && val.id == 4 && !this.isTransaction) {
        this.isActiveDiscount = true;
      }

    },

  },

  computed: {
    isAllSelected: {
      get() {
        return this.sortedPaymentGroups && this.sortedPaymentGroups.length > 0 && this.selectedPaymentGroup.length === this.sortedPaymentGroups.length;
      },
      set(val) {
        if (val) {
          this.selectedPaymentGroup = [...this.sortedPaymentGroups];
        } else {
          this.selectedPaymentGroup = [];
        }
      }
    },

    orderBillEntries() {
      try {
        // currentCart.cartEntries'den orderBillEntries'i oluştur, isTime ve totalHour bilgilerini koru
        let currentCart = this.$store.getters["selfservice/getCurrentCart"];
        
        // FIX [v22]: Polling sırasında cart.active kaybolursa UUID bazlı geri yükle (Fallback)
        if (!currentCart && this.localBranchTableUId) {
           console.warn("orderBillEntries (Mobile Recovery): currentCart is NULL, attempting recovery by UUID:", this.localBranchTableUId);
           const allCarts = this.$store.getters["selfservice/getCarts"];
           currentCart = allCarts.find(c => c && c.branchTableUId == this.localBranchTableUId);
           if (currentCart) console.log("orderBillEntries: Cart found in fallback (UUID).");
        }

        console.log("orderBillEntries (mobile) - currentCart:", currentCart);

        if (!currentCart || !currentCart.cartEntries) {
          console.log("orderBillEntries (mobile): currentCart veya cartEntries yok");
          return [];
        }

        console.log("orderBillEntries (mobile) - cartEntries:", currentCart.cartEntries);

        // cartEntries'i kopyala ve süreli ürün bilgilerini ekle
        const result = currentCart.cartEntries.map(entry => {
            // v147 [Custom Logic]: Kullanıcının DB yapısına göre IsRunning=false ise süreli üründür.
            const rawIsRunning = (entry.isRunning !== undefined) ? entry.isRunning : (entry.IsRunning !== undefined ? entry.IsRunning : true);
            const isTimedRaw = (rawIsRunning === false) && (entry.lastStartTime || entry.LastStartTime || entry.lastStopTime || entry.LastStopTime || (entry.hourPrice > 0) || (entry.HourPrice > 0));

            // Güvenli kopyalama
            const processedEntry = {
              id: entry.id,
              productName: entry.productName,
              price: entry.price,
              originPrice: entry.originPrice || entry.price,
              quantity: entry.quantity,
              productQuantity: entry.productQuantity,
              note: entry.note,
              variantItems: entry.variantItems || [],
              description: entry.description,
              // Süreli ürün bilgileri
              isTime: isTimedRaw,
              totalHour: entry.totalHour || entry.TotalHour || 0,
              isRunning: rawIsRunning,
              hourPrice: entry.hourPrice || entry.HourPrice || 0,
              time: entry.time || entry.Time,
              createdDate: entry.createdDate,
              userName: entry.userName,
              recipe: entry.recipe,
              extras: entry.extras,
              lastStartTime: entry.lastStartTime || entry.LastStartTime,
              lastStopTime: entry.lastStopTime || entry.LastStopTime,
            };

            // v147.1: Eğer süreli ürünse ve totalHour yoksa, zaman damgalarından hesapla (Duration = Stop - Start)
            if (processedEntry.isTime && (!processedEntry.totalHour || processedEntry.totalHour <= 0)) {
                const start = this.parseSafeDate(processedEntry.lastStartTime || processedEntry.createdDate);
                const stop = this.parseSafeDate(processedEntry.lastStopTime || new Date());
                if (start.getTime() > 0 && stop.getTime() >= start.getTime()) {
                    processedEntry.totalHour = (stop.getTime() - start.getTime()) / (1000 * 60 * 60);
                }
            }

          // v111.6: Reçete isim güvenliği (Adisyon/Snapshot öncesi - Max Safety)
          const targetRecipe = processedEntry.recipe || processedEntry.Recipe || processedEntry.recipeSteps || processedEntry.RecipeSteps;
          if (targetRecipe && targetRecipe.steps) {
            targetRecipe.steps.forEach(step => {
              if (step.isRemoved) {
                const rawMat = step.rawMaterial || step.RawMaterial || step.raw_material;
                const pName = step.productName || step.ProductName || (step.product && (step.product.name || step.product.Name));
                const safeName = (rawMat && (rawMat.name || rawMat.Name)) ? (rawMat.name || rawMat.Name) : 
                               (pName ? pName : (step.name || step.Name || "Malzeme"));
                if (!step.name || step.name === "Malzeme") step.name = safeName;
                if (!step.Name || step.Name === "Malzeme") step.Name = safeName;
                if (!step.productName) step.productName = safeName;
              }
            });
            processedEntry.recipe = targetRecipe;
          }

          return processedEntry;
        });

        console.log("orderBillEntries (mobile) result:", result);
        return result;
      } catch (error) {
        console.error("orderBillEntries (mobile) error:", error);
        return [];
      }
    },

    hasTimeProducts() {
      return this.paymentGroups.some(group =>
        group.entries.some(entry => entry.isTime)
      );
    },

    // Seçilen ödeme gruplarında çalışan süreli ürün var mı kontrol et
    hasRunningTimeProducts() {
      // Eğer hiç seçim yapılmamışsa tüm grupları kontrol et
      const groupsToCheck = this.selectedPaymentGroup.length > 0
        ? this.selectedPaymentGroup
        : this.paymentGroups;

      return groupsToCheck.some(group =>
        group.entries.some(entry => entry.isTime && entry.isRunning)
      );
    },

    printerSettings() {

      return this.$store.getters["selfservice/getPrinterSettings"];

    },

    isLoading: {

      get() {

        return this.$store.getters["selfservice/getIsLoading"];

      },

      set(val) {

        this.$store.dispatch("selfservice/setIsLoading", val);

      },

    },

    isCakeQuestioned: {

      get() {

        return this.$store.getters["selfservice/getCakeQuestioned"];

      },

      set(val) {

        this.$store.dispatch("selfservice/setCakeQuestioned", val);

      },

    },

    totalDiscountPrice: function () {
      const origin = parseFloat(this.totalOriginPrice) || 0;
      
      // 1. Sepet/Kampanya bazlı indirimler
      let basketDiscounts = (this.discounts || []).reduce((sum, d) => {
          let val = parseFloat(d.priceToDiscount || d.price || d.value || 0);
          if (!d.priceToDiscount && !d.price && (d.unit === '%' || d.unit === 1 || d.unit === "1")) {
              return sum + (origin * val / 100);
          }
          return sum + val;
      }, 0);

      // 2. Ödeme bazlı indirimler (id:4=İndirim, id:15=Kampanya)
      let logDiscounts = (this.orderPayments || []).reduce((sum, p) => {
          if (p.paymentMethod && (p.paymentMethod.id == 4 || p.paymentMethod.id == 15)) {
              let pVal = parseFloat(p.price || p.value || 0);
              if (pVal > 0 && !p.price && (p.unit === '%' || p.unit === 1 || p.unit === "1")) {
                  return sum + (origin * pVal / 100);
              }
              return sum + pVal;
          }
          return sum;
      }, 0);

      // 3. Ürün Bazlı İndirimler (OriginLineTotal - CurrentLineTotal)
      let campaignDiscounts = (this.paymentGroups || []).reduce(function (total, num) {
        let groupDiscount = (num.entries || []).reduce(function (entriesTotal, entry) {
          let originUnitPrice = parseFloat(entry.originPrice || entry.OriginPrice);
          let currentLineTotal = parseFloat(entry.price || entry.Price || 0);

          if (originUnitPrice) {
            let originLineTotal = Math.max(originUnitPrice || 0, currentLineTotal || 0);
            if (originLineTotal > currentLineTotal) {
              return entriesTotal + (originLineTotal - currentLineTotal);
            }
          }
          return entriesTotal;
        }, 0);
        return total + groupDiscount;
      }, 0);

      return Math.round((basketDiscounts + logDiscounts + campaignDiscounts) * 100) / 100;
    },

    discountPercentageText() {
      if (!this.orderPayments) return null;
      const percentageDiscounts = this.orderPayments.filter(p => p.paymentMethod && p.paymentMethod.id == 4 && p.unit == '%');
      if (percentageDiscounts.length > 0) {
        const uniqueValues = [...new Set(percentageDiscounts.map(p => p.value))];
        if (uniqueValues.length === 1) {
          return `%${uniqueValues[0]}`;
        } else {
          return `%...`;
        }
      }
      return null;
    },

    totalPaidAmount() {
      if (!this.orderPayments) return 0;
      return this.orderPayments.reduce((total, num) => {
        // v109: İndirim (4) ve Kampanya (15) dışındaki gerçek ödemeleri topla
        if (num.paymentMethod && (num.paymentMethod.id == 4 || num.paymentMethod.id == 15)) {
          return total;
        }
        return total + (parseFloat(num.price) || 0);
      }, 0);
    },

    isActiveDiscount: {
      get() {
        return this.$refs.discount.isActive;
      },
      set(val) {
        if (this.hasRunningTimeProducts && val) {
          this.$vs.notify({
            color: "warning",
            title: "Uyarı",
            text: "Çalışan süreli ürün varken indirim uygulanamaz!",
          });
          return;
        }
        this.$refs.discount.isActive = val;
      },
    },

    selectedPaymentMethod: {

      get() {

        return this.$store.getters["selfservice/getSelectedPaymentMethod"];

      },

      set(val) {

        if (val)

          this.$store.dispatch("selfservice/setSelectedPaymentMethod", val);

      },

    },

    paymentMethods: function () {

      return this.$store.getters["selfservice/getPaymentMethods"];

    },

    isReset: {

      get() {

        return this.$store.getters["selfservice/getToIsReset"];

      },

      set(val) {

        this.$store.dispatch("selfservice/setIsReset", val);

      },

    },

    totalOriginPrice: function () {

      return this.calculateTotalOriginPrice(this.paymentGroups);

    },

    totalPrice: function () {

      return this.calculateSelectedRemainingPrice(this.paymentGroups);

    },

    selectedGroupsPrice: function () {

      return this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);

    },

    currentCart: {

      get() {
        let cart = this.$store.getters["selfservice/getCurrentCart"];
        
        // FIX [v22]: Polling sırasında cart.active kaybolursa UUID bazlı geri yükle (Fallback)
        if (!cart && this.localBranchTableUId) {
           const allCarts = this.$store.getters["selfservice/getCarts"];
           cart = allCarts.find(c => c && c.branchTableUId == this.localBranchTableUId);
        }
        
        return cart;
      },

      set(payload) {

        this.$store.dispatch("selfService/setCurrentCartWithCampaign", payload);

      },

    },

    activePersonel: {
      get() {
        var personal = this.$store.getters["selfservice/getActivePersonal"];

        // Eğer activePersonal null ise (örneğin sayfa yenilendiğinde), localStorage'dan kurtar
        if (!personal) {
          var userInfo = JSON.parse(localStorage.getItem("userInfo"));
          if (userInfo) {
            this.$store.dispatch("selfservice/setActivePersonal", userInfo);
            return userInfo;
          }
        }
        return personal;
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal", val);
      },
    },

    toggleCalc: {
      get() {
        return this.isCalculatorPageActive;
      },
      set(val) {
        this.isCalculatorPageActive = val;
        this.$nextTick(() => {
          if (this.$refs.calculatorPage) {
            this.$refs.calculatorPage.isActive = val;
          }
        });
      },
    },

    sortedPaymentGroups() {
      if (!this.paymentGroups) return [];
      return [...this.paymentGroups].sort((a, b) => {
        // createdDate üzerinden sırala (en yeni en üstte)
        const dateA = (a.entries && a.entries[0] && a.entries[0].createdDate) ? new Date(a.entries[0].createdDate) : null;
        const dateB = (b.entries && b.entries[0] && b.entries[0].createdDate) ? new Date(b.entries[0].createdDate) : null;

        if (dateA && dateB) {
          return dateB - dateA;
        }

        // Tarih yoksa rowIndex (ID) üzerinden dene
        return b.rowIndex - a.rowIndex;
      });
    },
  },

  methods: {
    // v136: Tarih geçerliliğini kontrol et (0001-01-01 gibi hatalı değerleri yakalar)
    isValidDate(dateString) {
      if (!dateString) return false;
      const d = new Date(dateString);
      if (isNaN(d.getTime())) return false;
      // 2010 yılından öncesini hatalı kabul ediyoruz
      return d.getFullYear() >= 2010;
    },

    // v138.7: Güvenli Tarih Ayrıştırıcı (ISO ve Türk formatlarını destekler)
    parseSafeDate(val) {
      if (!val) return new Date(0);
      if (val instanceof Date) return val;
      
      // Standart ISO kontrolü
      let d = new Date(val);
      if (!isNaN(d.getTime())) {
          // v138.8: Turkey Timezone Bug Fix
          // Eğer tarih "Z" ile bitiyorsa ve "now"dan 2 saatten fazla ilerideyse, 
          // muhtemelen yerel saat (UTC+3) yanlışlıkla Z ile işaretlenmiştir.
          const now = new Date();
          if (d.getTime() > now.getTime() + 3600000) {
              // 3 saat geri çek (Yerel saate dönüştür)
              d = new Date(d.getTime() - 3 * 3600000);
          }
          return d;
      }
      
      // Türk formatı kontrolü (GG.AA.YYYY SS:dd:ss)
      if (typeof val === "string" && val.includes(".")) {
          try {
              const parts = val.split(/[. :]/);
              if (parts.length >= 3) {
                  const day = parseInt(parts[0]);
                  const month = parseInt(parts[1]) - 1;
                  const year = parseInt(parts[2]);
                  const hour = parts[3] ? parseInt(parts[3]) : 0;
                  const min = parts[4] ? parseInt(parts[4]) : 0;
                  const sec = parts[5] ? parseInt(parts[5]) : 0;
                  return new Date(year, month, day, hour, min, sec);
              }
          } catch(e) { console.error("parseSafeDate mobile fallback error", e); }
      }
      return new Date(0);
    },

    // v138.6: Virgül/Nokta ayrımı yapmadan sayıları güvenli parse et
    parseSafeNum(x) {
      if (typeof x === "number") return x;
      if (typeof x === "string") return parseFloat(x.replace(",", ".")) || 0;
      return Number(x) || 0;
    },

    // v138.9: Koşu ve Durma mantığını birbirinden ayır (Sadece koşuyorsa anlık hesap yap)
    getSafeTotalMs(entry) {
      if (!entry) return 0;
      
      let totalMs = 0;
      const accumulatedHour = this.parseSafeNum(entry.totalHour);

      // EĞER KOŞUYORSA: Anlık süreyi hesapla + birikmiş süreyi ekle
      if (entry.isRunning) {
        const now = new Date();
        const start = entry.lastStartTime || entry.createdDate;
        const startTime = this.parseSafeDate(start);
        
        if (startTime.getFullYear() >= 2010) {
          const elapsed = now - startTime;
          // Makul süre kontrolü (0 - 1000 saat arası)
          if (elapsed > 0 && elapsed < 3600000000) {
            totalMs += elapsed;
          }
        }
        
        // Birikmiş saati ekle
        if (!isNaN(accumulatedHour) && accumulatedHour > 0) {
          totalMs += accumulatedHour * 3600000;
        }
      } 
      // EĞER DURMUŞSA: Sadece DB'deki totalHour değerine güven (Extra hesap yapma)
      else {
        if (!isNaN(accumulatedHour) && accumulatedHour > 0) {
          totalMs = accumulatedHour * 3600000;
        }
      }

      return Math.round(totalMs);
    },

    calculateTimeDuration(entry) {
      if (!entry || (!entry.isTime && !entry.startTime && !entry.lastStartTime)) return '00:00:00';
      
      const totalMs = this.getSafeTotalMs(entry);

      const hours = Math.floor(totalMs / (1000 * 60 * 60));
      const minutes = Math.floor((totalMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((totalMs % (1000 * 60)) / 1000);

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
     },

    // v138.1: Zaman aralığını formatla (Başlangıç - Bitiş (X dk))
    getDisplayTimeRange(entry) {
      if (!entry || (!entry.isTime && !entry.startTime && !entry.lastStartTime)) return '';
      
      const start = this.isValidDate(entry.lastStartTime) ? entry.lastStartTime : entry.createdDate;
      const startTimeStr = start ? new Date(start).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }) : '--:--';
      
      let endTimeStr = '...';
      if (!entry.isRunning && this.isValidDate(entry.lastStopTime)) {
        endTimeStr = new Date(entry.lastStopTime).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
      } else if (entry.isRunning) {
        endTimeStr = 'Devam';
      }

      const totalMs = this.getSafeTotalMs(entry);
      const totalMinutes = Math.ceil(totalMs / 60000);

      return `${startTimeStr}-${endTimeStr}(${totalMinutes} dk)`;
    },

    // Süreli ürün için anlık fiyat hesapla (sadece arayüz için)
    calculateCurrentPrice(paymentGroup) {
      if (!paymentGroup.entries || paymentGroup.entries.length === 0) {
        return paymentGroup.totalPrice;
      }

      const entry = paymentGroup.entries.find(e => e.isTime);

      // Süreli ürün değilse veya fiyat bilgisi yoksa mevcut fiyatı döndür
      if (!entry || !entry.hourPrice) {
        return paymentGroup.totalPrice;
      }

      const totalMs = this.getSafeTotalMs(entry);
      
      // Toplam süreyi dakikalar cinsinden hesapla (kesirli olabilir)
      const totalMinutes = totalMs / (1000 * 60);


      // Saatlik ücreti dakika başına ücrete çevir
      const pricePerMinute = entry.hourPrice / 60;

      // Toplam dakikayı yukarı yuvarlayarak (örneğin 7.5 dakika -> 8 dakika) dakika bazında yeni fiyatı hesapla
      const newPrice = Math.max(0.1, Math.ceil(totalMinutes)) * pricePerMinute;

      // Ödenen miktarı çıkararak kalan tutarı döndür
      return Math.max(0, newPrice - paymentGroup.payedPrice);
    },

     formatHours(totalHours) {
       if (!totalHours) return '00:00:00';

       const hours = Math.floor(totalHours);
       const minutes = Math.floor((totalHours - hours) * 60);
       const seconds = Math.floor(((totalHours - hours) * 60 - minutes) * 60);

       return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
     },

     async stopTimeProduct(paymentGroup, overrideStopTime = null, overrideStartTime = null) {
       try {
         this.isTimerActionInProgress = true;
         const currentCart = JSON.parse(JSON.stringify(this.$store.getters["selfservice/getCurrentCart"]));
         if (!currentCart) {
           this.isTimerActionInProgress = false;
           return;
         }

         const localEntry = paymentGroup.entries[0];
         const entry = currentCart.cartEntries.find(item => item.id === localEntry.id);
         
         if (!entry) {
           this.isTimerActionInProgress = false;
           this.$vs.notify({ color: "danger", title: "Hata", text: "Ürün sepette bulunamadı!" });
           return;
         }
         if (!entry.isRunning) {
           this.isTimerActionInProgress = false;
           return;
         }

         // Capture original values for logging
         const originalStart = entry.lastStartTime || entry.createdDate;
         const originalStartDate = this.parseSafeDate(originalStart);
         const originalStop = entry.lastStopTime;

         if (overrideStartTime) {
           if (entry.lastStartTime) {
             entry.lastStartTime = overrideStartTime.toISOString();
           } else {
             entry.createdDate = overrideStartTime.toISOString();
           }
           this.$set(localEntry, 'lastStartTime', entry.lastStartTime);
           this.$set(localEntry, 'createdDate', entry.createdDate);
         }

         const now = overrideStopTime || new Date();
         const totalMs = this.getSafeTotalMs(entry, now);
         const totalMinutes = totalMs / (1000 * 60);

         console.log(`[TimerSTOP-Mobile] Product: ${entry.productName}, totalMs: ${totalMs}, totalMinutes: ${totalMinutes}`);

         this.$set(entry, 'totalHour', totalMinutes / 60);
         this.$set(entry, 'isRunning', false);
         this.$set(entry, 'lastStopTime', now.toISOString());

         if (entry.hourPrice) {
           const pricePerMinute = entry.hourPrice / 60;
           const newPrice = Math.max(0.1, Math.ceil(totalMinutes)) * pricePerMinute;
           entry.price = newPrice;
           entry.originPrice = newPrice;
         }

         this.$set(localEntry, 'totalHour', entry.totalHour);
         this.$set(localEntry, 'isRunning', false);
         this.$set(localEntry, 'lastStopTime', entry.lastStopTime);
         this.$set(localEntry, 'price', entry.price);
         this.$set(localEntry, 'originPrice', entry.originPrice);

         currentCart.totalPrice = currentCart.cartEntries.reduce((total, e) => total + e.price, 0);

         this.$store.dispatch('selfservice/updateCartsById', [currentCart]);
         this.reCalculatePaymentGroup();
         await this.saveCartToServer();

          // Log the time change action if it was an override
          if (overrideStartTime || overrideStopTime) {
            const formatTime = (d) => {
              if (!d) return "Devam Ediyor";
              const dateObj = new Date(d);
              if (isNaN(dateObj.getTime())) return d;
              const pad = (n) => n.toString().padStart(2, '0');
              const day = pad(dateObj.getDate());
              const month = pad(dateObj.getMonth() + 1);
              const year = dateObj.getFullYear();
              const hours = pad(dateObj.getHours());
              const minutes = pad(dateObj.getMinutes());
              return `${day}.${month}.${year} ${hours}:${minutes}`;
            };
            const originalStartStr = formatTime(originalStartDate);
            const originalStopStr = originalStop ? formatTime(originalStop) : "Devam Ediyor";
            const newStartStr = formatTime(overrideStartTime || originalStartDate);
            const newStopStr = formatTime(now);

            const systemLogDescription = `İşlem öncesi: Başlangıç: ${originalStartStr} - Bitiş: ${originalStopStr} | İşlem sonrası: Başlangıç: ${newStartStr} - Bitiş: ${newStopStr}`;

            await addDiscountLog({
              tableId: currentCart.tableId || 0,
              ids: [entry.id],
              totalDiscount: 0,
              discountType: "",
              actionType: "TimeChange",
              description: systemLogDescription,
              items: [entry]
            });
          }

         setTimeout(() => {
           this.isTimerActionInProgress = false;
         }, 2000);

         this.$vs.notify({
           color: "warning",
           title: "Süre Durduruldu",
           text: `${entry.productName} için süre durduruldu. Toplam: ${this.formatHours(entry.totalHour)}`,
         });
       } catch (err) {
         this.isTimerActionInProgress = false;
         this.$vs.notify({ color: "danger", title: "Hata", text: err.toString() });
               }
      },

      // v138.2: Tüm çalışan süreleri tek seferde durdur (Mobile)
      async stopAllRunningTimeProducts() {
        try {
          this.isTransaction = true;
          this.isTimerActionInProgress = true;

          const currentCart = JSON.parse(JSON.stringify(this.$store.getters["selfservice/getCurrentCart"]));
          if (!currentCart) {
            this.isTransaction = false;
            this.isTimerActionInProgress = false;
            return;
          }

          let stoppedCount = 0;
          const now = new Date();

          // Mobil: Tüm payment gruplarını tara
          this.paymentGroups.forEach(group => {
            const timedEntries = group.entries.filter(e => (e.isTime || e.startTime) && e.isRunning);
            
            timedEntries.forEach(localEntry => {
              const cartEntry = currentCart.cartEntries.find(item => item.id === localEntry.id);
              if (cartEntry && cartEntry.isRunning) {
                const totalMs = this.getSafeTotalMs(cartEntry);
                const totalMinutes = totalMs / (1000 * 60);

                console.log(`[TimerSTOP-All-Mobile] Product: ${cartEntry.productName}, totalMs: ${totalMs}`);

                // Değerleri mühürle
                this.$set(cartEntry, 'totalHour', totalMinutes / 60);
                this.$set(cartEntry, 'isRunning', false);
                this.$set(cartEntry, 'lastStopTime', now.toISOString());

                if (cartEntry.hourPrice) {
                  const pricePerMinute = cartEntry.hourPrice / 60;
                  const newPrice = Math.max(0.1, Math.ceil(totalMinutes)) * pricePerMinute;
                  cartEntry.price = newPrice;
                  cartEntry.originPrice = newPrice;
                }

                // UI yansıması
                this.$set(localEntry, 'totalHour', cartEntry.totalHour);
                this.$set(localEntry, 'isRunning', false);
                this.$set(localEntry, 'lastStopTime', cartEntry.lastStopTime);
                this.$set(localEntry, 'price', cartEntry.price);
                this.$set(localEntry, 'originPrice', cartEntry.originPrice);
                
                stoppedCount++;
              }
            });
          });

          if (stoppedCount > 0) {
            currentCart.totalPrice = currentCart.cartEntries.reduce((total, e) => total + e.price, 0);
            this.$store.dispatch('selfservice/updateCartsById', [currentCart]);
            this.reCalculatePaymentGroup();
            await this.saveCartToServer();

            this.$vs.notify({
              color: "warning",
              title: "Tüm Süreler Durduruldu",
              text: `${stoppedCount} adet ürünün süresi durduruldu.`
            });
          }

          setTimeout(() => {
            this.isTimerActionInProgress = false;
            this.isTransaction = false;
          }, 2000);

        } catch (err) {
          this.isTimerActionInProgress = false;
          this.isTransaction = false;
          this.$vs.notify({ color: "danger", title: "Hata", text: err.toString() });
        }
      },

      async startTimeProduct(paymentGroup) {
      try {
        const currentCart = JSON.parse(JSON.stringify(this.$store.getters["selfservice/getCurrentCart"]));
        if (!currentCart) return;

        const localEntry = paymentGroup.entries[0];
        if (!localEntry.isTime || localEntry.isRunning) return;

        // Herhangi bir ödeme yapılmış süreli ürün tekrar başlatılamaz
        if (paymentGroup.payedPrice > 0) {
          this.$vs.notify({
            color: "warning",
            title: "Uyarı",
            text: "Ödeme yapılmış süreli ürün tekrar başlatılamaz!",
          });
          this.isTransaction = false;
          return;
        }

        const now = new Date();
        localEntry.isRunning = true;
        localEntry.lastStartTime = now.toISOString();

        // Find and update the corresponding entry in the cloned cart
        const cartEntry = currentCart.cartEntries.find(item => item.id === localEntry.id);
        if (cartEntry) {
          cartEntry.isRunning = true;
          cartEntry.lastStartTime = localEntry.lastStartTime;
        }

        // Dispatch update to store
        this.$store.dispatch('selfservice/updateCartsById', [currentCart]);

        // Payment group fiyatını yeniden hesapla
        this.reCalculatePaymentGroup();

        // Cart'ı sunucuya kaydet
        await this.saveCartToServer();

        this.$vs.notify({
          color: "success",
          title: "Süre Başlatıldı",
          text: `${localEntry.productName} için süre başlatıldı.`,
        });
      } catch (err) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: err.toString()
        });
      }
    },

    mergeSelectedProducts() {

      if (this.selectedPaymentGroup.length <= 1) {

        this.$vs.notify({

          color: "warning",

          title: "Uyarı",

          text: "Birleştirilecek en az 2 ürün seçmelisiniz.",

        });

        return;

      }



      // Seçilen grupları sakla ve ödenen tutarı hesapla

      this.selectedGroupsForMerge = [...this.selectedPaymentGroup];

      this.totalPayedPriceForMerge = 0;

      this.selectedGroupsForMerge.forEach((group) => {

        this.totalPayedPriceForMerge += group.payedPrice || 0;

      });



      // Modal aç ve input temizle

      this.newMergePrice = "";

      this.isMergeModalOpen = true;



      // Input'a focus ver

      this.$nextTick(() => {

        if (this.$refs.txtMergePrice) {

          this.$refs.txtMergePrice.focus();

        }

      });

    },

    confirmMergeFromModal() {

      const newPrice = parseFloat(this.newMergePrice);



      if (!newPrice || newPrice <= 0) {

        this.$vs.notify({

          color: "warning",

          title: "Uyarı",

          text: "Geçerli bir fiyat giriniz.",

        });

        return;

      }



      if (newPrice < this.totalPayedPriceForMerge) {

        this.$vs.notify({

          color: "warning",

          title: "Uyarı",

          text: `Yeni fiyat en az ${this.$toCurrency(this.totalPayedPriceForMerge)} olmalıdır (ödenen tutar).`,

        });

        return;

      }



      // Modal kapat

      this.isMergeModalOpen = false;

      this.newMergePrice = "";



      // Birleştirme işlemini yap

      this.confirmMerge(newPrice);

    },

    cancelMerge() {

      this.isMergeModalOpen = false;

      this.newMergePrice = "";

      this.selectedGroupsForMerge = [];

      this.totalPayedPriceForMerge = 0;

    },

    confirmMerge(newPrice) {

      // Seçilen grupların verilerini hesapla

      let totalOriginalPrice = 0;

      let totalPayedPrice = 0;

      this.selectedGroupsForMerge.forEach((group) => {

        totalOriginalPrice += group.totalPrice || 0;

        totalPayedPrice += group.payedPrice || 0;

      });



      // Fiyat farkını hesapla

      const priceDifference = totalOriginalPrice - newPrice;



      // Yeni birleştirilmiş grup oluştur

      let mergedGroup = {

        rowIndex: uuid.v1(),

        entries: [],

        totalPrice: newPrice,

        payedPrice: totalPayedPrice,

        status: "Kalan",

      };



      // Tüm entry'leri birleştir

      this.selectedGroupsForMerge.forEach((group) => {

        mergedGroup.entries = mergedGroup.entries.concat(group.entries);

      });



      // Entry fiyatlarını ayarla (ilk entry'ye tüm fiyat, diğerleri 0)

      if (mergedGroup.entries.length > 0) {

        mergedGroup.entries[0].price = newPrice;

        for (let i = 1; i < mergedGroup.entries.length; i++) {

          mergedGroup.entries[i].price = 0;

        }

      }



      // Seçilen grupları kaldır ve yeni grubu ekle

      let remainingGroups = this.paymentGroups.filter((group) =>

        !this.selectedGroupsForMerge.some((selected) => selected.rowIndex === group.rowIndex)

      );

      remainingGroups.push(mergedGroup);

      this.paymentGroups = remainingGroups;



      // Eğer fiyat indirimi varsa, Kampanya ödeme yöntemi olarak ekle

      if (priceDifference > 0) {

        let campaignPayment = {

          id: uuid.v1(),

          paymentMethod: {

            id: 15, // Kampanya payment method ID'si

            name: "Kampanya"

          },

          price: priceDifference,

          value: priceDifference,

          unit: "₺",

          description: "Ürün Birleştirme İndirimi",

          discountDescription: `${this.$toCurrency(totalOriginalPrice)} → ${this.$toCurrency(newPrice)}`,

        };

        this.orderPayments.push(campaignPayment);

      }



      // Seçimi temizle

      this.selectedPaymentGroup = [];

      this.selectedGroupsForMerge = [];

      this.totalPayedPriceForMerge = 0;



      // Fiyatları yeniden hesapla

      this.reCalculatePaymentGroup();



      // Cart'ı sunucuya kaydet

      this.saveCartToServer();



      this.$vs.notify({

        color: "success",

        title: "Başarılı",

        text: `Seçilen ürünler ${this.$toCurrency(newPrice)} fiyatı ile birleştirildi.`,

      });

    },

    async saveCartToServer() {
      try {
        var cart = _.cloneDeep(this.$store.getters["selfservice/getCurrentCart"]);
        if (!cart) return;

        cart.paymentGroups = _.cloneDeep(this.paymentGroups);
        cart.orderPayments = _.cloneDeep(this.orderPayments);
        cart.discounts = _.cloneDeep(this.discounts);
        
        // Bakiyeyi her zaman güncel tut ki masa kapanma sorunu yaşanmasın
        cart.totalPayedPrice = cart.orderPayments.reduce((total, p) => total + (parseFloat(p.price) || 0), 0);
        cart.remainingAmount = Math.round((cart.totalPrice - cart.totalPayedPrice) * 100) / 100;

        await setBranchCart({ 
          value: cart, 
          tableId: cart.tableId,
          branchTableUId: cart.branchTableUId // UUID bazlı birincil anahtar
        });
      } catch (error) {
        console.error("Cart kaydedilemedi:", error);
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Değişiklikler sunucuya kaydedilemedi.",
        });
      }
    },

    toggleRowSelection(row) {

      const index = this.selectedPaymentGroup.findIndex(item => item.rowIndex === row.rowIndex);

      if (index === -1) {

        this.selectedPaymentGroup.push(row);

      } else {

        this.selectedPaymentGroup.splice(index, 1);

      }

    },

    showPaymentScreen(branchTableUId, branchId) {
      // ARMOR [v26]: Eğer dışarıdan null gelirse Store'dan son bir kez kurtarmayı dene
      if (!branchTableUId) {
          const storeCart = this.$store.getters['selfservice/getCurrentCart'];
          if (storeCart && storeCart.branchTableUId) {
              branchTableUId = storeCart.branchTableUId;
              console.log("[ARMOR v26-Mobile] Recovery: branchTableUId recovered from Store:", branchTableUId);
          }
      }

      if (branchTableUId) {
          this.localBranchTableUId = branchTableUId;
          console.log("showPaymentScreen (mobile): Setting localBranchTableUId (anchor):", branchTableUId);
      }
      if (branchId) {
          this.localBranchId = branchId;
      }
      this.isActive = true;
      this.initValues();
      this.initGifts();
    },

    closePaymentScreen() {

      this.isActive = false;

      this.$emit('close');

    },

    printBill(){

      this.isPrinting = true;

      const rowIndexes = this.selectedPaymentGroup.map(selected => selected.rowIndex);

      console.log("printBill", rowIndexes);

      this.$emit("printBill", rowIndexes, this.printCopyCount);




      // Simulate print delay and reset loading state

      setTimeout(() => {

        this.isPrinting = false;

      }, 2000);

    },

    changeCart(newCart){
      if(!newCart || !this.currentCart || newCart.id != this.currentCart.id) return;
      this.isTransaction = true; // Senkronizasyon sırasında koru

        this.paymentGroups = newCart.paymentGroups;

        this.orderPayments = newCart.orderPayments;

        this.selectedPaymentGroup = [];

        this.generatePaymentGroups();

        this.$nextTick(() => {
          this.isTransaction = false; // DOM güncellenince korumayı kaldır
        });

    },

    checkScreen() {

      this.isMobile = window.innerWidth <= 768;

    },

    commitQrCode(customer) {

      this.$store.dispatch("selfservice/setCurrentCartCustomer", customer);

    },

    getTotalGift(row) {

      let totalGift = row.entries.reduce(function (total, num) {

        if (num.originPrice - num.price > 0)

          return total + (num.originPrice - num.price);

        else return total + 0;

      }, 0);

      return this.$toCurrency(totalGift);

    },

    breakToRow: async function () {

      console.log("breakToRow",this.selectedPaymentGroup);

      let currentCart = {

          ...this.$store.getters["selfservice/getCurrentCart"],

        };

        var selectedSinglePaymentGroup = this.selectedPaymentGroup[0];

        let breakResult = await breakToRow(selectedSinglePaymentGroup.rowIndex, currentCart.tableId);

        console.log("breakResult",breakResult.data);

        this.paymentGroups = breakResult.data.paymentGroups;

        this.selectedPaymentGroup = [];

        this.generatePaymentGroups();

    },
    showDescriptionPrompt(text, callback) {
      this.descriptionPromptText = text;
      this.descriptionPromptCallback = callback;
      this.pendingDescription = "";
      this.isDescriptionPromptActive = true;
    },
    async confirmDescriptionPrompt() {
      if (this.pendingDescription && this.pendingDescription.trim() !== "") {
        if (this.descriptionPromptCallback) {
          await this.descriptionPromptCallback(this.pendingDescription);
        }
        this.isDescriptionPromptActive = false;
        this.pendingDescription = "";
        this.descriptionPromptCallback = null;
      }
    },
    cancelDescriptionPrompt() {
      this.isDescriptionPromptActive = false;
      this.pendingDescription = "";
      this.descriptionPromptCallback = null;
    },
    ClearCart: async function () {
      if (this.selectedPaymentGroup.length === 0) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Lütfen silinecek ürünleri seçiniz.",
        });
        this.isTransaction = false;
        return;
      }

      // v118.V35 [SAFETY-MOBILE]: Ödeme veya İndirim yapılmış kalemlerin silinmesini engelle
      const blockedItems = this.selectedPaymentGroup.filter(item => {
        const itemPrice = (parseFloat(item.totalPrice) || 0);
        if (itemPrice > 0) {
          // Sadece fiyatı > 0 olan ürünler için ödeme veya indirim kontrolü yap
          const hasPayment = (parseFloat(item.payedPrice) || 0) > 0;
          const hasDiscount = item.entries && item.entries.some(entry => 
            (parseFloat(entry.originPrice) || parseFloat(entry.price) || 0) > (parseFloat(entry.price) || 0)
          );
          return hasPayment || hasDiscount;
        }
        // Fiyatı 0 olan ürünler her zaman silinebilir
        return false;
      });

      if (blockedItems.length > 0) {
        this.$vs.notify({
          color: "warning",
          title: "İşlem Engellendi",
          text: "Ödeme yapılmış veya indirim uygulanmış ürünler silinemez.",
        });
        this.isTransaction = false;
        return;
      }

      this.showDescriptionPrompt("Seçili ürünleri silmek için lütfen bir açıklama giriniz.", async (description) => {
        // FIX [400/422 Error]: Görünen masa no (558) yerine veritabanı ID'sini (Numeric) kullan
        const cart = this.currentCart || {};
        const targetTableId = cart.branchTableId || cart.realId || ( (!isNaN(cart.id) && cart.id > 1000) ? cart.id : cart.tableId );
        const targetCartId = cart.id || null;
        
        console.log(`[v400-FIX] Mobile ClearCart targeting TableID: ${targetTableId} (Display/UI: ${cart.tableId})`);
        
        const selectedGroupSnapshot = _.cloneDeep(this.selectedPaymentGroup || []);
        const deletedEntries = selectedGroupSnapshot.flatMap(pg => pg.entries || []);
        const selectedRowIndexes = selectedGroupSnapshot.map(x => x.rowIndex);

        if (!targetTableId) {
          this.isLoading = false;
          this.$vs.notify({ color: "danger", title: "Hata", text: "Masa bilgisi alınamadı." });
          return;
        }

        try {
          this.isLoading = true;

          // 1. Store'dan sil
          this.$store.dispatch(
            "selfservice/removeEntryFromCurrentCart",
            selectedGroupSnapshot
          );

          this.$store.dispatch("selfservice/setToUpdateEntry", null);

          // 2. Yerel paymentGroups'u güncelle
          this.paymentGroups = (this.paymentGroups || []).filter(
            (pg) => !selectedRowIndexes.includes(pg.rowIndex)
          );

          // 3. API çağrısı yap - FIX [400 Error]: rowIndex yerine gerçek entry.id'leri gönder
          const entryIdsToDelete = deletedEntries.map(e => e.id).filter(id => id != null);

          const result = await removeToCartIds(
            entryIdsToDelete,
            targetTableId,
            description
          );

          // 4. Sepetleri tazele
          let cartsResponse = await getCarts();
          let carts = cartsResponse.data;

          if (carts && carts.length > 0) {
            this.$store.dispatch(
              "selfservice/setToCart",
              carts.map((cart) => ({
                ...cart,
                // FIX: Sabitlenen ID ve gevşek karşılaştırma (==) ile aktif masayı koru
                active: cart.tableId == targetTableId,
              }))
            );
          }

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Seçili ürünler sepetten silindi.",
          });

          // [v125] Multi-Kitchen Printer Routing (İPTAL FİŞİ - MOBILE): Group deleted items by printer and trigger separately
          try {
            if (deletedEntries.length > 0 && (targetTableId || targetCartId)) {
                const sidToPrint = this.localBranchTableUId || targetTableId || targetCartId;
                const finalTableName = this.tableName || "Masa";

                const uniquePrinters = new Set();
                deletedEntries.forEach(entry => {
                  const kitchen = (this.kitchens || []).find(k => k.id === entry.kitchenId);
                  const pName = (kitchen && (kitchen.printerName || kitchen.PrinterName)) ? (kitchen.printerName || kitchen.PrinterName) : "Mutfak";
                  uniquePrinters.add(pName);
                });

                if (uniquePrinters.size === 0) uniquePrinters.add("Mutfak");

                uniquePrinters.forEach(printer => {
                  triggerKitchenPrintBySID(sidToPrint, printer, finalTableName, false)
                    .then(res => console.log(`[v125] Mobile Cancellation Trigger Success:`, res))
                    .catch(err => console.error(`[v125] Mobile Cancellation Trigger Failed:`, err));
                });
            }
          } catch (printErr) {
             console.warn("Mobile kitchen print failed but flow continues:", printErr);
          }

          // 5. Sepet boşaldıysa ve ödeme kaydı yoksa müşteri durumu sor (Kullanıcı kuralı)
          const updatedCart = carts ? carts.find(c => c.tableId == targetTableId) : null;
          if ((this.orderPayments || []).length == 0 && (!updatedCart || !updatedCart.cartEntries || updatedCart.cartEntries.length == 0)) {
            this.isCakeQuestioned = false;

            this.$vs.dialog({
              type: "confirm",
              color: "warning",
              title: "Müşteri Durumu",
              text: "Sepet boşaldı. Müşteri masadan kalktı mı?",
              acceptText: "Evet, Kalktı",
              cancelText: "Hayır, Hala Oturuyor",
              accept: async () => {
                if (targetTableId) {
                  try {
                    await unReserveTable(targetTableId);
                  } catch (reErr) {
                    console.warn("Mobile unreserve failed:", reErr);
                  }
                }
                this.$store.dispatch("selfservice/removeCart", targetCartId);
                this.$vs.notify({
                  color: "success",
                  title: "Masa Durumu Güncellendi",
                  text: "Masa boş olarak işaretlendi.",
                });
                this.selectedPaymentGroup = [];
                this.paymentGroups = [];
                this.$emit("switchToTableMap");
                this.isActive = false;
              },
              cancel: () => {
                this.$vs.notify({
                  color: "info",
                  title: "Masa Durumu Güncellendi",
                  text: "Masa dolu olarak işaretlendi.",
                });
                this.selectedPaymentGroup = [];
                this.paymentGroups = [];
                this.$emit("switchToTableMap");
                this.isActive = false;
              },
            });
          } else {
            this.initValues();
          }
        } catch (error) {
          console.error("[v400-DEBUG] ClearCart error full:", error);
          if (error.response && error.response.data) {
             console.error("[v400-DEBUG] API error response data:", error.response.data);
             if (error.response.data.Message || error.response.data.message) {
                this.$vs.notify({ color: "danger", title: "İşlem Reddedildi", text: error.response.data.Message || error.response.data.message , time: 6000 });
             } else {
                this.$vs.notify({ color: "danger", title: "API Hatası", text: JSON.stringify(error.response.data) , time: 6000 });
             }
          }
          this.isLoading = false;
        } finally {
          this.isLoading = false;
        }
      });
    },

    initValues() {
      if(!this.currentCart) return;
      this.selectedGift = null;
      this.orderPayments = _.cloneDeep(this.currentCart.orderPayments || []);
      this.paymentGroups = _.cloneDeep(this.currentCart.paymentGroups || []);
      this.selectedPaymentGroup = [];

      // eslint-disable-next-line no-undef

      this.cloneCurrentCart = _.cloneDeep(this.currentCart);
      this.localMergedIds = (this.currentCart && this.currentCart.mergedIds) ? [...this.currentCart.mergedIds] : [];
      this.generatePaymentGroups();

      this.$nextTick(() => {
        this.isTransaction = false;
      });

    },
    async loadKitchens() {
      try {
        const res = await getAllKitchen();
        this.kitchens = res.data || [];
      } catch (err) {
        console.error("OrderListPaymentMobile: Kitchens load failed:", err);
      }
    },
    generatePaymentGroups() {
      if(!this.currentCart || !this.currentCart.cartEntries) return;
      // this.paymentGroups.length = 0;
      this.currentCart.cartEntries.forEach((entry) => {

        if (!this.paymentGroups.some((group) => group.rowIndex === entry.id)) {

          let tempPaymentGroup = {

            rowIndex: entry.id,

            entries: [],

            totalPrice: 0,

            payedPrice: 0,

            status: "Kalan",

          };

          tempPaymentGroup.rowIndex = entry.id;

          tempPaymentGroup.entries.push(entry);

          tempPaymentGroup.totalPrice = entry.price;

          tempPaymentGroup.payedPrice = 0;

          tempPaymentGroup.status = "Kalan";

          this.paymentGroups.push(_.cloneDeep(tempPaymentGroup));

        }

      });

      this.reCalculatePaymentGroup();

    },

    initGifts() {
      if(!this.currentCart || !this.currentCart.cartEntries) return;
      if (this.currentCart.customer) {
        let cart = this.currentCart;
        cart.cartEntries.forEach((x) => {
          if (x.categories && x.categories.length > 0) {
            x.categoryId = x.categories[0].id;
          }
        });

        let payments = this.orderPayments;

        let orderModel = {

          id: cart.id,

          customerId: cart.customer ? cart.customer.id : null,

          qrCode: cart.customer ? cart.customer.giftQrCode : null,

          totalPrice: cart.totalPrice,

          active: cart.active,

          cartEntries: [...cart.cartEntries],

          branchName: this.$currentUser.branch.name,

          paymentInformations: [...payments],

          userName: this.activePersonel ? this.activePersonel.name : "",

          userId: this.activePersonel ? this.activePersonel.id : null,

        };

        FindAvailableCampaigns(orderModel)

          .then((res) => {

            if (res && res.status == 200) {

              if (res.data.isValid) {

                let clonedCart = Object.assign({}, this.currentCart);

                clonedCart.cartEntries = res.data.newEntries;

                if (res.data.customerGiftId != null)

                  clonedCart.customerGiftId = res.data.customerGiftId;

                else if (res.data.campaignGiftId != null)

                  clonedCart.campaignGiftId = res.data.campaignGiftId;

                this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);

                this.generatePaymentGroups();

              }

            } else {

              this.$fire({

                title: "Hata : " + res.status,

                text: "Kampanyalara Erişilemedi !",

                type: "error",

              });

              this.$vs.notify({

                color: "danger",

                title: "Hata : " + res.status,

                text: "Kampanyalara Erişilemedi !",

              });

            }

          })

          .catch(() => {

            this.$fire({

              title: "Hata !",

              text: "Sunucu Bağlantı Hatası !",

              type: "error",

            });

            this.$vs.notify({

              color: "danger",

              title: "Hata !",

              text: "Sunucu Bağlantı Hatası !",

            });

          });

      }

    },

    openDiscountModal() {
      if (!this.currentCart) return;
      this.$refs.discount.isActive = true;
    },

    async resetDiscount() {
      try {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: "İndirim Sıfırla",
          text: "Uygulanan tüm indirimleri sıfırlamak istediğinize emin misiniz?",
          acceptText: "Evet",
          cancelText: "Vazgeç",
          accept: async () => {
            this.isLoading = true;
            this.isTransaction = true;

            const currentCartData = this.$store.getters['selfservice/getCurrentCart'];
            if (!currentCartData) return;
            const currentCart = JSON.parse(JSON.stringify(currentCartData));

            // 1. İndirimli ödemeleri ve kampanyaları temizle
            this.orderPayments = this.orderPayments.filter(p => p.paymentMethod && p.paymentMethod.id != 4 && p.paymentMethod.id != 15);
            this.discounts = [];
            currentCart.orderPayments = JSON.parse(JSON.stringify(this.orderPayments));
            currentCart.discounts = [];
            currentCart.totalPayedPrice = 0;
            currentCart.campaignGiftId = null;
            currentCart.customerGiftId = null;

            // 2. Ürün fiyatlarını orijinal haline döndür
            currentCart.cartEntries.forEach(entry => {
              // v153: Restore to original, but ensure it doesn't drop below the line current if origin is just a unit price
              entry.price = Math.max(parseFloat(entry.originPrice || 0), parseFloat(entry.price || 0));
            });

            // 3. PaymentGroups'u TAMAMEN tazele
            this.paymentGroups = [];
            currentCart.cartEntries.forEach((entry) => {
              let tempPaymentGroup = {
                rowIndex: entry.id,
                entries: [JSON.parse(JSON.stringify(entry))],
                totalPrice: entry.price,
                payedPrice: 0,
                status: "Kalan",
              };
              this.paymentGroups.push(tempPaymentGroup);
            });

            // 4. Tutarları ve store'u güncelle
            currentCart.totalPrice = currentCart.cartEntries.reduce((total, e) => total + (parseFloat(e.price) || 0), 0);
            currentCart.totalPrice = Math.round(currentCart.totalPrice * 100) / 100;
            currentCart.remainingAmount = currentCart.totalPrice;
            currentCart.paymentGroups = JSON.parse(JSON.stringify(this.paymentGroups));
            
            await this.$store.dispatch('selfservice/updateCartsById', [currentCart]);
            this.reCalculatePaymentGroup();
            
            // 5. Sunucuya kaydet
            await setBranchCart({ 
              value: currentCart, 
              tableId: currentCart.tableId, 
              branchTableUId: currentCart.branchTableUId 
            });

            // 6. Log StaffAction (İndirim İptal)
            try {
              if (currentCart && currentCart.cartEntries) {
                const logIds = currentCart.cartEntries.map(e => e.id);
                await addDiscountLog({
                  tableId: currentCart.id,
                  branchTableUId: currentCart.branchTableUId,
                  branchId: currentCart.branchId,
                  ids: logIds,
                  totalDiscount: 0,
                  discountType: "Discount",
                  actionType: "Reset",
                  description: "İndirim İptal"
                });
                console.log("Discount Reset Log Success (Mobile)");
              }
            } catch (logErr) {
              console.error("Discount Reset Log Error (Mobile):", logErr);
            }

            // 7. Version Sync (v155-Mobile)
            try {
              let res = await getOrderEntries(currentCart.id);
              if (res && res.data && res.data.rowVersion) {
                  currentCart.rowVersion = res.data.rowVersion;
                  await this.$store.dispatch('selfservice/updateCartsById', [currentCart]);
                  console.log("Discount Reset Version Sync Success (Mobile)");
              }
            } catch (vErr) {
              console.error("Discount Reset Version Sync Error (Mobile):", vErr);
            }

            this.isLoading = false;
            this.isTransaction = false;

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Tüm indirimler ve kampanyalar sıfırlandı.",
            });
          }
        });
      } catch (err) {
        console.error("resetDiscount error:", err);
        this.isLoading = false;
        this.isTransaction = false;
        this.$vs.notify({ color: "danger", title: "Hata", text: err.toString() });
      }
    },

    printFromPreview() {
      if (this.$refs.printer) {
        this.$refs.printer.printOrders();
      }
    },

    async appendDiscount(discountObj) {
      // Eğer kalem seçili değilse tüm kalemleri baz al
      let targetGroups = (this.selectedPaymentGroup && this.selectedPaymentGroup.length > 0)
        ? this.selectedPaymentGroup
        : this.paymentGroups;

      // Tüm girişlerin ID'lerini topla (kalem bazlı indirim için)
      let logIds = [];
      targetGroups.forEach(group => {
        if (group.entries && group.entries.length > 0) {
          group.entries.forEach(entry => {
            logIds.push(entry.id);
          });
        }
      });

      // Find the "İndirim" payment method (ID 4 or 15) to ensure correct tracking
      const discountMethod = this.paymentMethods.find(m => m.id == 4 || m.id == 15 || m.name.toLowerCase().includes('indirim'));

      this.paymentDiscount = {
        paymentMethod: discountMethod || this.selectedPaymentMethod,
        value: discountObj.value,
        description: discountObj.description,
        unit: discountObj.unit,
        selectedPaymentGroup: logIds,
        payedPrice: discountObj.payedPrice,
        discountDescription: discountObj.discountDescription,
      };

      // this.isTransaction = true; // REVERTED: doPayWithoutPos handles this state natively to avoid deadlocks.
      
      // 1. İndirim logunu at ve sepeti tazele
      try {
        if (!this.currentCart) {
            console.error("appendDiscount (mobile): currentCart is NULL!");
            return;
        }

        await addDiscountLog({
          tableId: this.currentCart.id,
          ids: logIds,
          totalDiscount: discountObj.priceToDiscount,
          discountType: "Discount",
          actionType: "Discount",
          description: discountObj.description
        });

        // Safe Version Sync (v7): Sepeti tazele ama kalemleri ve UI state'ini asla bozma.
        if (this.currentCart && this.currentCart.id) {
           let res = await getOrderEntries(this.currentCart.id);
           if (res && res.data && res.data.rowVersion) {
              this.currentCart.rowVersion = res.data.rowVersion;
              console.log("Safe Version Sync (Mobile): RowVersion güncellendi (v7).");
           }
        }
      } catch (logError) {
        console.error("Discount log error (mobile atomic):", logError);
      }

      // 2. Ödemeye devam et (Tazelenmiş sepet üzerinden)
      this.discounts.push(this.paymentDiscount);
      await this.doPayWithoutPos(discountObj.priceToDiscount, true);

      this.paymentDiscount = {};
    },

    returnSelectedExtraVariant(extra) {
      let returnObj = [];
      extra.variants.forEach((x) => {
        if (x.quantity > 0) {
          returnObj.push("x" + x.quantity + " / " + x.name);
        }
      });
      return returnObj.length > 0 ? returnObj : null;
    },

    createCommitModel: async function () {
      if (Math.round(this.totalPrice * 100) < 0) {
        console.warn("createCommitModel: Sipariş toplam tutarı negatif veya boş, işlem iptal edildi.");
        return;
      }
      if (this.isTransaction == true) {
        this.isTransaction = false;
        return;
      }

      // 0. SEPET KURTARMA (RECOVERY) - Polling sırasında null gelirse store'dan UUID bazlı geri al
      let cartSnapshot = this.currentCart ? JSON.parse(JSON.stringify(this.currentCart)) : null;
      if (!cartSnapshot && this.localBranchTableUId) {
          console.warn("createCommitModel (Early Recovery): currentCart is NULL, attempting to recover by UUID (anchor):", this.localBranchTableUId);
          const allCarts = this.$store.getters["selfservice/getCarts"];
          const recovered = allCarts.find(c => c && c.branchTableUId == this.localBranchTableUId);
          if (recovered) {
              cartSnapshot = JSON.parse(JSON.stringify(recovered));
              cartSnapshot.active = true; 
              console.log("createCommitModel: Cart recovered successfully by UUID (mobile).");
          }
      }
      if (!cartSnapshot) {
          console.error("createCommitModel (mobile): CRITICAL - Sepet verisine ulaşılamadı (Recovery failed)!");
          this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: "Sepet verisine ulaşılamadı. Lütfen tekrar deneyiniz.",
          });
          this.isTransaction = false;
        return;
      }

      this.isTransaction = true;
      this.isLoading = true;

      try {
        let synchronizedEntries = [];
        if (this.paymentGroups && this.paymentGroups.length > 0) {
          this.paymentGroups.forEach(group => {
            if (group.entries && group.entries.length > 0) {
              group.entries.forEach(entry => {
                synchronizedEntries.push(entry);
              });
            }
          });
        }
        
        // v118.Beta-Final-17.V4 [FROZEN-SNAPSHOT-MOBILE]: Sipariş tamamlanmadan hemen önce sepeti tam kopya ile dondur.
        // Bu sayede "Adisyon Yazdırma" ekranındaki stabiliteyi ödeme fişine de taşıyoruz.
        const frozenCart = JSON.parse(JSON.stringify(this.currentCart || {}));
        if (frozenCart) {
            // Computed değerleri o anki doğru halleriyle (sum-based) oku ve dondur
            this.snapshotTotalOriginPrice = parseFloat(this.totalOriginPrice) || 0;
            this.snapshotTotalDiscountPrice = parseFloat(this.totalDiscountPrice) || 0;
            this.snapshotTotalPrice = parseFloat(this.totalPrice) || 0;
            this.snapshotTotalPaidAmount = parseFloat(this.totalPaidAmount) || 0;
            this.snapshotOrderPayments = frozenCart.orderPayments ? JSON.parse(JSON.stringify(frozenCart.orderPayments)) : [];
            this.snapshotBillEntries = this.orderBillEntries ? JSON.parse(JSON.stringify(this.orderBillEntries)) : [];
            this.snapshotTableName = this.tableName;

            // Yazıcı modeli için ek alanları dondur
            frozenCart.totalOriginPrice = Math.round(this.snapshotTotalOriginPrice * 100) / 100;
            frozenCart.totalDiscountPrice = Math.round(this.snapshotTotalDiscountPrice * 100) / 100;
            frozenCart.totalPrice = Math.round((parseFloat(this.totalPrice) || 0) * 100) / 100;
            frozenCart.totalPayedPrice = Math.round((parseFloat(this.totalPaidAmount) || 0) * 100) / 100;
            frozenCart.tableName = this.snapshotTableName;
            frozenCart.isAdisyon = false;

            // [V4-CONCURRENCY-FIX]: Prop'lar üzerinden değil, direkt parametre ile dondurulmuş objeyi yazdır!
            if (this.$refs.printer) {
                this.$nextTick(() => {
                    // v118.V6 [DB-SYNC-PRINT]: Yerel tetik silindi, API başarısı sonrasına taşındı.
                });
            }
        }
        
        let cart = cartSnapshot;
        // v118.Final: Snapshot atamaları yukarıda yapıldı, gereksizleri temizle.

        if (this.isTableMode && cart && cart.id) {
            try {
                const latestCartRes = await getOrderEntries(cart.id);
                if (latestCartRes && latestCartRes.data) {
                    if (latestCartRes.data.rowVersion) {
                        cart.rowVersion = latestCartRes.data.rowVersion;
                        console.log("[v29-Mobile] RowVersion updated from Cart API:", cart.rowVersion);
                    } else {
                        console.warn("[v29-OrderListPayment-Mobile] Cart API returned NULL rowVersion, attempting Master Sync...");
                        try {
                            // [v37-OMEGA-RESERVE] Force wake-up call to the server
                            console.log("[v37-OMEGA-RESERVE] Mobile Forcing server-side table reservation for:", cartSnapshot.tableId);
                            try {
                                await reserveTable(cartSnapshot.tableId);
                                const freshCartsRes = await getCarts();
                                if (freshCartsRes && freshCartsRes.data) {
                                    this.$store.dispatch("selfservice/setToCart", freshCartsRes.data);
                                    const serverCart = freshCartsRes.data.find(c => c && c.tableId == cartSnapshot.tableId);
                                    if (serverCart) {
                                        cart.rowVersion = serverCart.rowVersion;
                                        cart.id = serverCart.id;
                                        cart.realId = serverCart.id;
                                        // [v39-OMEGA-UUID] Server UUID is the absolute Law
                                        if (serverCart.branchTableUId) {
                                            cart.branchTableUId = serverCart.branchTableUId;
                                        }
                                        console.log("[v39-OMEGA-UUID-Mobile] Synchronized - RowVersion:", cart.rowVersion, "RealId:", cart.id, "UUID:", cart.branchTableUId);
                                    }
                                }
                            } catch (resErr) { console.error("[v37-OMEGA-RESERVE-Mobile] Reserve/Pull Failed:", resErr); }

                            const masterTableRes = await getCartsByTableId(cart.id || cart.tableId);
                            if (masterTableRes && masterTableRes.data && masterTableRes.data.rowVersion) {
                                cart.rowVersion = masterTableRes.data.rowVersion;
                                console.log("[v29-MASTER-SYNC-Mobile] RowVersion recovered from BranchTables:", cart.rowVersion);
                                if (!cart.branchTableUId && masterTableRes.data.branchTableUId) {
                                  cart.branchTableUId = masterTableRes.data.branchTableUId;
                                }
                            }
                        } catch (masterErr) {
                            console.error("[v29-MASTER-SYNC-Mobile] Master Sync Failed:", masterErr);
                        }
                    }

                    // CRITICAL: UUID Missing in Snapshot? Fix it from local or store or GENERATE [v26 ARMOR-HEAL]
                    if (!cart.branchTableUId) {
                        cart.branchTableUId = latestCartRes.data.branchTableUId || this.localBranchTableUId || (this.$store.getters['selfservice/getCurrentCart'] ? this.$store.getters['selfservice/getCurrentCart'].branchTableUId : null);
                        
                        if (!cart.branchTableUId) {
                            cart.branchTableUId = uuid.v1();
                            console.warn("[ARMOR v26-HEAL-Mobile] UUID STILL NULL. Generated new one:", cart.branchTableUId);
                        }
                    }
                    console.log("[Atomic Sync v26-HEAL-Mobile] Final Snapshot Data:", { 
                        rowVersion: cart.rowVersion, 
                        branchTableUId: cart.branchTableUId 
                    });
                }
            } catch(e) { console.error("[Atomic Sync v26-Mobile] Failed:", e); }
        }

        // [v36-DEEP-SYNC] Masa Numarası -> Gerçek Sunucu ID'si Eşleşmesi
        let serverSideTableId = cart.tableId; 
        try {
            const allCarts = this.$store.getters["selfservice/getCarts"] || [];
            const serverCart = allCarts.find(c => c && (c.tableId == cart.tableId));
            if (serverCart && serverCart.id && serverCart.id > 1000) {
                serverSideTableId = serverCart.id;
                console.log(`[v36-DEEP-SYNC] Mobile Mapped Table ${cart.tableId} to ServerID: ${serverSideTableId}`);
            }
        } catch (deepErr) { console.error("[v36-DEEP-SYNC] Lookup Failed:", deepErr); }

        // [v40-DEEP-FORCE] Eğer hala RowVersion yoksa (Hayalet Sepet), sunucuya zorla kaydet
        if (this.isTableMode && !cart.rowVersion) {
            console.warn("[v40-FORCE-SAVE-Mobile] RowVersion still missing. Forcing server record creation...");
            try {
                console.log("[v40-DEBUG-Mobile] Force Save Payload:", { value: cart, tableId: cart.id || cart.tableId, branchTableUId: cart.branchTableUId });
                const forceSaveRes = await setBranchCart({ 
                    value: cart, 
                    tableId: cart.id || cart.tableId, 
                    branchTableUId: cart.branchTableUId 
                });
                console.log("[v40-DEBUG-Mobile] Force Save Response:", forceSaveRes);
                if (forceSaveRes && forceSaveRes.data) {
                    const sData = forceSaveRes.data;
                    // [v40-DEEP-FORCE] Capture EVERYTHING from the server response
                    cart.rowVersion = sData.rowVersion || sData.RowVersion;
                    if (sData.id || sData.Id) {
                        const newId = sData.id || sData.Id;
                        cart.id = newId;
                        cart.realId = newId;
                        cart.tableId = newId; // [v40] Anchor tableId to the record ID
                        serverSideTableId = newId;
                        console.log("[v40-DEEP-FORCE-Mobile] ID Anchored to Server Record ID:", cart.id);
                    }
                    if (sData.branchTableUId || sData.BranchTableUId) {
                        cart.branchTableUId = sData.branchTableUId || sData.BranchTableUId;
                    }
                    console.log("[v40-DEEP-FORCE-Mobile] Sync Success. RowVersion:", cart.rowVersion, "UUID:", cart.branchTableUId);
                }
            } catch (forceErr) {
                console.error("[v40-DEEP-FORCE-Mobile] Force Save Failed:", forceErr);
            }
        }

        // v107+: Termal Yazıcı İçin Veri Zenginleştirme (Snapshot'a enjekte et)
        if (cart) {
            cart.totalOriginPrice = parseFloat(this.totalOriginPrice) || 0;
            cart.totalDiscountPrice = parseFloat(this.totalDiscountPrice) || 0;
            // v109: Ödenen tutar olarak indirimleri içermeyen gerçek ödeme toplamını gönder
            cart.totalPayedPrice = parseFloat(this.totalPaidAmount) || 0;
            cart.isAdisyon = false; // Ödeme fişi olduğu için false
            
            if (cart.cartEntries) {
                cart.cartEntries.forEach(entry => {
                    if (!entry.originPrice) entry.originPrice = entry.price;
                    
                    // v111 [SAFETY]: Reçete adımlarında is_removed olanların ismini garantiye al
                    if (entry.recipe && entry.recipe.steps) {
                        entry.recipe.steps.forEach(step => {
                            if (step.isRemoved && (!step.name || step.name === "Malzeme")) {
                                step.name = (step.rawMaterial && (step.rawMaterial.name || step.rawMaterial.Name)) ? (step.rawMaterial.name || step.rawMaterial.Name) : 
                                           (step.productName ? step.productName : "Malzeme");
                            }
                        });
                    }
                });
            }
        }

        let orderModel = {
          id: cart.id || 0,
          tableId: cart.branchTableUId || (this.$store.getters['selfservice/getCurrentCart'] ? this.$store.getters['selfservice/getCurrentCart'].branchTableUId : null),
          branchTableUId: cart.branchTableUId || (this.$store.getters['selfservice/getCurrentCart'] ? this.$store.getters['selfservice/getCurrentCart'].branchTableUId : null),
          rowVersion: cart.rowVersion || null,
          isNavigatedByQuestion: cart.isNavigatedByQuestion,
          customerId: cart.customer ? cart.customer.id : null,
          totalPrice: cart.totalPrice,
          userName: this.activePersonel ? `${this.activePersonel.name} ${this.activePersonel.surname}` : null,
          userId: this.activePersonel ? this.activePersonel.id : null,
          discounts: [...(this.discounts || [])],
          cart: JSON.parse(JSON.stringify(cart)),
          paymentInformations: [...this.orderPayments],
          cartEntries: synchronizedEntries.length > 0 ? synchronizedEntries : cart.cartEntries,
          submissionId: this.submissionId || ("sub_" + Date.now()),
          branchId: this.$store.state.AppActiveUser.branch.id,
          orderStatus: 1,
          orderDeliveryType: 1
        };

        console.log("[ARMOR v27-Mobile] Final OrderModel to API:", orderModel);

        let result;
        try {
            result = await completePayment(orderModel);
            console.log("[v34-DEBUG-Mobile] completePayment Result:", result);
        } catch (err) {
            console.error("[v34-DEBUG-ERROR-Mobile] 422 Body:", err.response ? err.response.data : "No response data");
            this.$vs.notify({ color: "danger", title: "Hata", text: "Ödeme backend tarafından onaylanmadı." });
            this.isTransaction = false;
            return;
        }
        
        const isSuccess = (result === true) || (result && result.isValid !== false && (result.data ? result.data.isValid !== false : true));

        let proceedToCleanup = isSuccess;
        if (!isSuccess && result && typeof result === 'object' && result.data && result.data.rowVersion) {
            proceedToCleanup = true;
            console.log("[ARMOR v27-Mobile] Order appears already paid, proceeding to closure.");
        }

        if (!proceedToCleanup) {
            this.$vs.notify({ color: "danger", title: "Hata", text: "Ödeme backend tarafından onaylanmadı." });
            this.isTransaction = false;
            return;
        }

        console.log("completePayment Başarılı (mobile):", result);
        
        // v118.V9-Mobile [PREVIEW-DRIVEN]: Show preview modal on mobile instead of silent print
        if (this.isPrintOrders && this.$refs.printer) {
           this.isReceiptPreviewActive = true;
           this.localBranchTableUId = (this.currentCart ? this.currentCart.branchTableUId : null);
           this.localBranchId = (this.currentCart ? this.currentCart.branchId : null);
           
           // Fetch authoritative data for the preview
           if (this.localBranchTableUId && this.localBranchId) {
              this.$refs.printer.handleDBSuccessPrint(this.localBranchTableUId, this.localBranchId);
           }
        }
        
        // Finalize Closure (User request: Disable popup for now)
        let isFullTable = false;
        /*
        if (this.isTableMode) {
          await new Promise((resolve) => {
            this.$vs.dialog({
              type: "confirm", color: "warning", title: "Masa Durumu", text: "Müşteri masadan kalktı mı?",
              acceptText: "Evet, Kalktı", cancelText: "Hayır, Hala Oturuyor",
              accept: () => { isFullTable = false; resolve(); },
              cancel: () => { isFullTable = true; resolve(); },
            });
            setTimeout(() => resolve(), 10000); 
          });
        }
        */

        await this.finalizeClosure(cart, isFullTable);

      } catch (err) {
        console.error("[ARMOR v27-Mobile] createCommitModel Error:", err);
        
        // CRITICAL: Hata durumunda snapshot temizle
        this.submissionId = null;

        if (err.message && (err.message.includes("422") || err.message.includes("onaylamadı"))) {
           console.log("[ARMOR v27-Mobile] 422 Detected. Table will NOT be cleared.");
           this.$fire({ title: "Hata (422)!", text: "Sipariş sunucu tarafından reddedildi. Masa verisi korundu.", type: "error" });
        } else {
           this.$fire({ title: "Hata !", text: "Sipariş kaydedilemedi: " + (err.message || "Bilinmeyen hata"), type: "error" });
        }
        this.isTransaction = false;
      } finally {
        this.isLoading = false;
      }
    },

    finalizeClosure: async function(cart, isFullTable) {
      try {
        let targetIds = [];
        if (cart.tableId) targetIds.push(cart.tableId);
        if (cart.id && !targetIds.includes(cart.id)) targetIds.push(cart.id);
        
          const finalMergedIds = (this.localMergedIds && this.localMergedIds.length > 0) ? this.localMergedIds : (cart.mergedIds || []);
          if (finalMergedIds && Array.isArray(finalMergedIds)) {
            finalMergedIds.forEach(id => { if (id && !targetIds.includes(id)) targetIds.push(id); });
          }

          for (let tid of targetIds) {
            if (!tid) continue;
            let clonedCartToSave = JSON.parse(JSON.stringify(cart));
            clonedCartToSave.id = tid;
            clonedCartToSave.tableId = tid;

            // CRITICAL (Mobile) [v23]: Kesin Klozür Mantığı
            const allCarts = this.$store.getters["selfservice/getCarts"] || [];
            const currentStoreCart = allCarts.find(c => c && c.tableId == tid);
            
            if (tid == cart.tableId) {
                // Ana masa: Mümkün olan en güncel versiyonu al
                if (currentStoreCart && currentStoreCart.rowVersion) {
                    clonedCartToSave.rowVersion = currentStoreCart.rowVersion;
                }
            } else {
                // İkincil masalar: Versiyonu sil ki çakışma (409) ihtimali sıfırlansın
                if (clonedCartToSave.rowVersion) {
                    delete clonedCartToSave.rowVersion;
                }
            }

            clonedCartToSave.paymentGroups = [];
            clonedCartToSave.cartEntries = [];
            clonedCartToSave.totalPrice = 0;
            clonedCartToSave.totalPayedPrice = 0;
            clonedCartToSave.orderPayments = [];
            clonedCartToSave.entries = [];
            clonedCartToSave.discounts = [];
            clonedCartToSave.mergedIds = [];
            clonedCartToSave.isMerged = false;
            clonedCartToSave.isMerge = false;

            // FIX: isFullTable parametresi "müşteri masada KALIYOR" ise true gelir.
            // Ama biz tüm bağlı masaların durumunu kontrol etmeliyiz.
            if (!isFullTable || cart.notSeat) {
                // UI Tarafında masayı hemen kaldır (Kritik: tid String olmalı)
                const tableIdToClear = String(tid);
                this.$store.dispatch("selfservice/removeCart", tableIdToClear);
                
                clonedCartToSave.active = false;
                clonedCartToSave.isFullTable = false;
                
                // Reset session for the next customer (Non-destructive update model)
                clonedCartToSave.branchTableUId = uuid.v1();
                
                try {
                    // 1. Standart deneme: Masayi silmek yerine sifirlıyoruz (Update)
                    await setBranchCart({ 
                      value: clonedCartToSave, 
                      tableId: tableIdToClear, 
                      branchTableUId: clonedCartToSave.branchTableUId, 
                      remove: false 
                    });
                } catch (cleanErr) {
                    // 2. Fallback: unReserveTable
                    console.warn(`Fallback (v25): unReserveTable for ${tableIdToClear} (mobile)`);
                    await unReserveTable(tableIdToClear).catch(e => console.error("Unreserve fail:", tableIdToClear, e));
                }
            } else {
               // Müşteri kalkmadıysa sadece ana masa aktif kalsın
               clonedCartToSave.active = (tid === cart.tableId);
               clonedCartToSave.isFullTable = true;
               clonedCartToSave.customer = null;
               this.$store.dispatch("selfservice/updateCartsById", [clonedCartToSave]);
               await setBranchCart({ 
                 value: clonedCartToSave, 
                 tableId: tid, 
                 branchTableUId: clonedCartToSave.branchTableUId, // UUID bazlı güncelleme
                 remove: false 
               }).catch(e => console.error("setBranchCart update fail (mobile):", tid, e));
            }
          }
      } catch (saveErr) {
        console.error("Closure save error (mobile):", saveErr);
      }

      this.discounts = [];
      this.isPieced = false;
      this.isActive = false; // ŞİMDİ KAPAT
      this.$emit("switchToTableMap");

    },

    seperatePayment() {
      // FIX: Panelin açılıp kapanma sorununu (glitch) önlemek için önce durumu sıfırla
      if (this.toggleCalc) {
        this.toggleCalc = false;
        if (this.$refs.calculatorPage) {
           this.$refs.calculatorPage.doNotCloseCalc = false;
        }
        this.$nextTick(() => {
          this.execSeperatePayment();
        });
      } else {
        if (this.$refs.calculatorPage) {
           this.$refs.calculatorPage.doNotCloseCalc = false;
        }
        this.execSeperatePayment();
      }
    },

    execSeperatePayment() {
      if (this.selectedPaymentGroup.length > 0) {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
          this.selectedPaymentGroup
        );
        this.toggleCalc = true;
      } else {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
          this.paymentGroups
        );
        this.toggleCalc = true;
      }
    },

    checkPosDevice: async function () {

      let userInfo = JSON.parse(localStorage.getItem("userInfo"));

      let branchId = userInfo.branch.id;

      let axiosResponse = await getPosSettings(branchId);

      localStorage.setItem("posSettings", JSON.stringify(axiosResponse.data));

      this.isPosEnabled = axiosResponse.data.enable;

      this.posType = axiosResponse.data.posType;

      this.posData = axiosResponse.data;

    },

    checkPosConnection: async function () {
      if (!this.isPosEnabled) {
        this.isPosConnectionError = false;
        return;
      }
      let bridgeUrl = process.env.VUE_APP_POS_API;
      if (!bridgeUrl) {
        this.isPosConnectionError = true;
        return;
      }
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 1500);

      try {
        const response = await fetch(bridgeUrl, {
          method: "GET",
          signal: controller.signal,
          headers: {
            "Accept": "application/json"
          }
        });
        clearTimeout(timeoutId);
        this.isPosConnectionError = false;
      } catch (err) {
        clearTimeout(timeoutId);
        this.isPosConnectionError = true;
        console.warn("POS Bridge connection check failed:", err);
      }
    },

    startPosConnectionTimer() {
      this.stopPosConnectionTimer();
      this.checkPosConnection();
      this.posConnectionInterval = setInterval(() => {
        this.checkPosConnection();
      }, 5000);
    },

    stopPosConnectionTimer() {
      if (this.posConnectionInterval) {
        clearInterval(this.posConnectionInterval);
        this.posConnectionInterval = null;
      }
    },

    setIsPieced: function () {

      this.isPieced = true;

    },

    doPayWithoutPos: async function (payedPrice, isDiscount) {
      if (this.isTransaction) return;
      this.isTransaction = true;

      console.log(payedPrice);

      // Seçilen gruplarda çalışan süreli ürün varsa ödeme yapılamaz
      if (this.hasRunningTimeProducts) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Seçilen ürünlerde çalışan süreli ürünler var. Önce onları durdurunuz!",
        });
        this.isTransaction = false;
        return;
      }

      console.log(this.paymentGroups);

      console.log(this.selectedPaymentGroup);



      if (
        this.selectedPaymentMethod.id == process.env.VUE_APP_WALLET_PAYMENT_ID
      ) {
        this.openQrReader(payedPrice, isDiscount);
        this.$nextTick(() => { this.isTransaction = false; });
        this.isTransaction = false;
        return;
      }



      // Eğer cari ödeme seçilmişse cari seçim popup'ını aç

      if (
        this.selectedPaymentMethod.id == process.env.VUE_APP_CARI_PAYMENT_ID &&
        !this.selectedCari
      ) {
        this.$refs.cariSelect.openPopup();
        this.$nextTick(() => { this.isTransaction = false; });
        this.isTransaction = false;
        return;
      }



      // Deep clone selectedPaymentGroup so modifications don't mutate Vuex
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.paymentGroups));
      } else {
        this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.selectedPaymentGroup));
      }

      // Oransal Dağıtım Mantığı (Safe Clone)
      var totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
      var distributedAmount = 0;
      var payedPriceFloat = parseFloat(payedPrice);

      this.selectedPaymentGroup.forEach((group, index) => {
        var remaining = group.totalPrice - group.payedPrice;
        var pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
        
        var chunk = 0;
        if (index === this.selectedPaymentGroup.length - 1) {
          chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
        } else {
          chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
        }
        
        group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
        if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
        distributedAmount += chunk;

        if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
          group.status = "Ödendi";
        }
      });

      // Yerel değişiklikleri ana listeye geri yansıt
      this.selectedPaymentGroup.forEach((modifiedGroup) => {
        let idx = this.paymentGroups.findIndex(pg => pg.rowIndex === modifiedGroup.rowIndex);
        if (idx !== -1) {
          this.$set(this.paymentGroups, idx, modifiedGroup);
        }
      });

      let selectedPgs = this.selectedPaymentGroup.map(pg => pg.rowIndex);
      
      this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
        this.selectedPaymentGroup
      );

      this.selectedPaymentGroup = [];

      this.reCalculatePaymentGroup();

      let orderPayment = {
        id: uuid.v1(),
        paymentMethod: isDiscount ? this.paymentDiscount.paymentMethod : this.selectedPaymentMethod,
        price: payedPrice,
        value: isDiscount ? this.paymentDiscount.value : null,
        unit: isDiscount ? this.paymentDiscount.unit : null,
        description: isDiscount ? this.paymentDiscount.description : null,
        discountDescription: isDiscount
          ? this.paymentDiscount.discountDescription
          : null,
        selectedPaymentGroup: selectedPgs,
      };

        // SAFE CLONE & RECOVERY: Reaktivite veya polling sırasında sepetin kaybolması durumuna karşı UUID koruması
        let clonedCart = Object.assign({}, this.currentCart || {});
        if (!clonedCart.id && this.localBranchTableUId) {
            console.warn("doPayWithoutPos: currentCart is NULL, attempting to recover by UUID (anchor):", this.localBranchTableUId);
            const allCarts = this.$store.getters["selfservice/getCarts"];
            const recovered = allCarts.find(c => c && c.branchTableUId === this.localBranchTableUId);
            if (recovered) {
                clonedCart = Object.assign({}, recovered);
                clonedCart.active = true; // Re-activate it locally
                console.log("doPayWithoutPos: Cart recovered successfully by UUID (mobile).");
            } else if (this.paymentGroups.length > 0) {
                console.error("doPayWithoutPos: CRITICAL - Cart could not be recovered even by UUID!");
            }
        }


      // Eğer cari ödeme yapılıyorsa, seçilen cari hesabın ID'sini ekle

      if (this.selectedPaymentMethod.id == process.env.VUE_APP_CARI_PAYMENT_ID && this.selectedCari) {

        orderPayment.cariId = this.selectedCari.id;

        orderPayment.cariName = this.selectedCari.name;

      }



      this.orderPayments.push(orderPayment);



      this.toggleCalc = false;



      // Sync with store for the next steps
      clonedCart.paymentGroups = JSON.parse(JSON.stringify(this.paymentGroups));
      clonedCart.totalPayedPrice = Math.round((clonedCart.totalPayedPrice + payedPrice) * 100) / 100;
      clonedCart.remainingAmount = Math.round((clonedCart.totalPrice - clonedCart.totalPayedPrice) * 100) / 100;
      clonedCart.orderPayments = JSON.parse(JSON.stringify(this.orderPayments));
      clonedCart.discounts = [...this.discounts];

      // CRITICAL: Birleşmiş masa bilgisini (mergedIds) her zaman koru
      if (this.localMergedIds && this.localMergedIds.length > 0) {
          clonedCart.mergedIds = [...this.localMergedIds];
          // CRITICAL [v22]: Ana masanın haritada görünür kalması için isMerged FALSE olmalıdır.
          clonedCart.isMerged = false;
      } else if (this.$store.getters["selfservice/getCurrentCart"].mergedIds) {
          clonedCart.mergedIds = [...this.$store.getters["selfservice/getCurrentCart"].mergedIds];
          // CRITICAL [v22]: Ana masanın haritada görünür kalması için isMerged FALSE olmalıdır.
          clonedCart.isMerged = false;
      }

      this.$store.dispatch("selfservice/updateCartsById", [clonedCart]);

      // SAFE SAVE: clondedCart zaten oluşturulmuş, tüm ürünleri ve birleşme verilerini içeriyor.
      let cartToSave = JSON.parse(JSON.stringify(clonedCart));
      cartToSave.active = true;
      cartToSave.isFullTable = true;
      const branchId = this.$store.state.AppActiveUser.branch.id;
      cartToSave.branchId = branchId;
      const saveRes = await setBranchCart({ 
        value: cartToSave, 
        tableId: cartToSave.tableId,
        branchTableUId: cartToSave.branchTableUId // UUID bazlı birincil anahtar
      });
      
      // CRITICAL [v21]: Birleşmiş masalar için Geliştirilmiş Ping Lojiği
      if (clonedCart.mergedIds && clonedCart.mergedIds.length > 0) {
          const allCarts = this.$store.getters["selfservice/getCarts"];
          for (const mId of clonedCart.mergedIds) {
              try {
                  let existingMCart = allCarts.find(c => c && c.tableId === mId);
                  let mValue = existingMCart ? JSON.parse(JSON.stringify(existingMCart)) : { tableId: mId };

                  mValue.branchId = branchId;
                  mValue.isFullTable = true;
                  mValue.active = true;
                  mValue.isMerged = true;
                  mValue.mergedIds = [...clonedCart.mergedIds];

                  await setBranchCart({ 
                    value: mValue, 
                    tableId: mId,
                    branchTableUId: mValue.branchTableUId // UUID bazlı birincil anahtar
                  });
              } catch (mErr) {
                  console.error("Secondary table safe ping error (v21):", mErr);
              }
          }
      }
      
      // CRITICAL: Backend'den dönen güncel RowVersion'u yakala ve objeye işle
      if (saveRes && saveRes.data && saveRes.data.rowVersion) {
          clonedCart.rowVersion = saveRes.data.rowVersion;
          // Store'u tekrar güncelle ki en taze veri kalsın
          this.$store.dispatch("selfservice/updateCartsById", [clonedCart]);
          console.log("Safe Version Sync (Mobile): RowVersion güncellendi.", saveRes.data.rowVersion);
      }

      this.$nextTick(() => {
        this.isTransaction = false; // İşlem başarıyla sunucuya kaydedildiğinde ve reaktif döngü bittiğinde bayrağı indir
        
        // Eğer ödeme tamamlandıysa otomatik olarak sepeti bitir
        if (this.totalPrice == 0 && this.isActive == true && !this.isLoading) {
          if (this.currentCart.cartEntries && this.currentCart.cartEntries.length > 0) {
            this.isCommitable = true;
            this.createCommitModel();
          }
        }
      });



      // Cari seçimini sıfırla

      this.selectedCari = null;

    },

    doPay: async function (payedPrice, isDiscount) {
      if (this.isTransaction && !isDiscount) return;
      this.isTransaction = true; // POS işlemi veya indirim süresince popup kapanmasın

      if (this.isPosConnectionError && !isDiscount && this.selectedPaymentMethod && 
          (this.selectedPaymentMethod.id == this.VUE_APP_CASH_PAYMENT_ID || this.selectedPaymentMethod.id == this.VUE_APP_CREDIT_PAYMENT_ID)) {
        this.$vs.notify({
          color: "danger",
          title: "Bağlantı Hatası",
          text: "POS Bridge bağlantısı olmadığı için ödeme yapılamaz!",
        });
        this.isTransaction = false;
        return;
      }

      // [v31-FORCE-SAVE] Eğer RowVersion yoksa (Hayalet Sepet), sunucuya zorla kaydet
      if (this.isTableMode && this.currentCart && !this.currentCart.rowVersion) {
          console.warn("[v33-FORCE-SAVE-Mobile] RowVersion still missing. Forcing server record creation...");
          try {
              const forceSaveRes = await setBranchCart({ 
                  value: this.currentCart, 
                  tableId: this.currentCart.id || this.currentCart.tableId, 
                  branchTableUId: this.currentCart.branchTableUId 
              });
              if (forceSaveRes && forceSaveRes.data) {
                  const sData = forceSaveRes.data;
                  // [v40-DEEP-FORCE] Capture EVERYTHING from the server response
                  this.currentCart.rowVersion = sData.rowVersion || sData.RowVersion;
                  if (sData.id || sData.Id) {
                      const newId = sData.id || sData.Id;
                      this.currentCart.id = newId;
                      this.currentCart.realId = newId;
                      this.currentCart.tableId = newId; // [v40] Anchor tableId to the record ID
                      console.log("[v40-DEEP-FORCE-Mobile-doPay] ID Anchored to Server Record ID:", newId);
                  }
                  if (sData.branchTableUId || sData.BranchTableUId) {
                      this.currentCart.branchTableUId = sData.branchTableUId || sData.BranchTableUId;
                  }
                  console.log("[v40-DEEP-FORCE-Mobile-doPay] Sync Success. RowVersion:", this.currentCart.rowVersion, "UUID:", this.currentCart.branchTableUId);
              }
          } catch (forceErr) {
              console.error("[v33-FORCE-SAVE-Mobile] Force Save Failed:", forceErr);
          }
      }

      // Seçilen gruplarda çalışan süreli ürün varsa ödeme yapılamaz
      if (this.hasRunningTimeProducts) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Seçilen ürünlerde çalışan süreli ürünler var. Önce onları durdurunuz!",
        });
        this.isTransaction = false;
        return;
      }





      if (this.posType == parseInt(process.env.VUE_APP_POS_GMP)) {

        this.doPayGmp(payedPrice, isDiscount);

        return;

      }



      // Eğer cari ödeme seçilmişse cari seçim popup'ını aç

      if (
        this.selectedPaymentMethod.id == process.env.VUE_APP_CARI_PAYMENT_ID &&
        !this.selectedCari &&
        !isDiscount
      ) {
        this.$refs.cariSelect.openPopup();
        this.$nextTick(() => { this.isTransaction = false; });
        this.isTransaction = false;
        return;
      }



      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }

      let posSaleItems = [];
      this.selectedPaymentGroup.forEach(function (selectProduct) {
        if (selectProduct.payedPrice != selectProduct.totalPrice) {
          let priceToPay = selectProduct.totalPrice - selectProduct.payedPrice;
          
          if (selectProduct.entries.length == 1) {
            let saleModel = {
              name: selectProduct.entries[0].productName,
              quantity: selectProduct.entries[0].quantity,
              kdv: selectProduct.entries[0].kdv,
              price: priceToPay,
            };
            posSaleItems.push(saleModel);
          } else {
            let groupRemaining = selectProduct.totalPrice - selectProduct.payedPrice;
            let groupDistributed = 0;

            selectProduct.entries.forEach((entry, eIdx) => {
              let entryRemaining = entry.price;
              let eRatio = groupRemaining > 0 ? (entryRemaining / selectProduct.totalPrice) : 0;
              let eChunk = 0;
              
              if (eIdx === selectProduct.entries.length - 1) {
                eChunk = Math.round((priceToPay - groupDistributed) * 100) / 100;
              } else {
                eChunk = Math.round((priceToPay * eRatio) * 100) / 100;
              }


              let saleModel = {
                name: entry.productName,
                quantity: entry.quantity,
                kdv: entry.kdv,
                price: eChunk,
              };
              posSaleItems.push(saleModel);
              groupDistributed += eChunk;
            });
          }
        }
      });

      this.isLoading = true;

      fetch(process.env.VUE_APP_POS_API + "complete-sale", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          PaymentType:
            this.selectedPaymentMethod.id ==
            process.env.VUE_APP_CREDIT_PAYMENT_ID
              ? 4
              : 1,
          SaleItems: posSaleItems,
        }),
      })
        .then((response) => response.json())
        .then(async (data) => {
          this.isLoading = false;
          if (data.hasError == true) {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: data.message,
            });
            this.$fire({
              title: "İptal",
              text: data.message,
              type: "error",
            });
            this.$nextTick(() => { this.isTransaction = false; });
            return;
          }
          const successStatuses = [3, 4, 5, 6, 8, 9, 10, 18, 19, 20, 21, 22, 24];
          if (data.data && successStatuses.includes(data.data.statusId)) {
            this.isPaymentStarted = true;
            let resultData = data.data;
            var posStatusId = this.getPaymentMethodIdFromPosResponse(resultData, this.selectedPaymentMethod.id);
            
            // Deep clone paymentGroups so modifications don't mutate Vuex
            if (this.selectedPaymentGroup.length == 0) {
              this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.paymentGroups));
            } else {
              // If already selected, ensure it's cloned independently
              this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.selectedPaymentGroup));
            }

            // Oransal Dağıtım Mantığı (Merge yerini alıyor)
            let totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
            let distributedAmount = 0;
            let payedPriceFloat = parseFloat(payedPrice);

            this.selectedPaymentGroup.forEach((group, index) => {
              let remaining = group.totalPrice - group.payedPrice;
              let pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
              
              var chunk = 0;
              if (index === this.selectedPaymentGroup.length - 1) {
                // Son kalem kuruş farklarını alır
                chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
              } else {
                chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
              }
              
              group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
              if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
              
              distributedAmount += chunk;

              if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
                group.status = "Ödendi";
              }
            });

            // Merge selected modifications back into the global paymentGroups list
            this.selectedPaymentGroup.forEach((modifiedGroup) => {
               let idx = this.paymentGroups.findIndex(pg => pg.rowIndex === modifiedGroup.rowIndex);
               if (idx !== -1) {
                 this.$set(this.paymentGroups, idx, modifiedGroup);
               }
            });

            var removeIndex = [];
            var tempGroup = {
              rowIndex: uuid.v1(),
              entries: [],
              totalPrice: 0,
              payedPrice: parseFloat(payedPrice),
              status: "Kalan",
            };
            var vm = this;

            this.paymentGroups.forEach((item) => {
              tempGroup.rowIndex = uuid.v1();
              if (vm.selectedPaymentGroup.some((s) => s.rowIndex == item.rowIndex)) {
                tempGroup.entries = tempGroup.entries.concat(item.entries);
                removeIndex.push(item.rowIndex);
              }
            });

            let removedPaymentGroup = [];
            this.paymentGroups.forEach((x, index) => {
              if (!removeIndex.some((rm) => rm == x.rowIndex)) {
                removedPaymentGroup.push(vm.paymentGroups[index]);
              }
            });
            removedPaymentGroup.push(tempGroup);
            this.paymentGroups = removedPaymentGroup;

            this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
              this.selectedPaymentGroup
            );
            this.selectedPaymentGroup = [];
            this.reCalculatePaymentGroup();

            let orderPayment = {
              id: uuid.v1(),
              // eslint-disable-next-line no-undef
              paymentMethod: _.cloneDeep(this.selectedPaymentMethod),
              price: payedPrice,
              value: isDiscount ? this.paymentDiscount.value : null,
              unit: isDiscount ? this.paymentDiscount.unit : null,
              description: isDiscount ? this.paymentDiscount.description : null,
            };
            orderPayment.paymentMethod.id = posStatusId;

            if (
              data.data.financialDocuments &&
              data.data.financialDocuments.length > 0
            ) {
              orderPayment.financialDocument = data.data.financialDocuments[0];
              orderPayment.financialDocument.saleUid = data.data.saleUid;
              orderPayment.financialDocument.orderNo = data.data.orderNo;
            }

            this.orderPayments.push(orderPayment);
            this.toggleCalc = false;

            // POS ödemesi başarılı, sunucuyu ve sepeti güncelle (doPayWithoutPos gibi)
            let clonedCart = _.cloneDeep(this.$store.getters["selfservice/getCurrentCart"]);
            clonedCart.paymentGroups = JSON.parse(JSON.stringify(this.paymentGroups));
            clonedCart.totalPayedPrice = Math.round((clonedCart.totalPayedPrice + payedPrice) * 100) / 100;
            clonedCart.orderPayments = JSON.parse(JSON.stringify(this.orderPayments));

            // CRITICAL: Birleşmiş masa bilgisini (mergedIds) her zaman koru
            if (this.localMergedIds && this.localMergedIds.length > 0) {
                clonedCart.mergedIds = [...this.localMergedIds];
                // CRITICAL [v22]: Ana masanın haritada görünür kalması için isMerged FALSE olmalıdır.
                clonedCart.isMerged = false;
            } else if (this.$store.getters["selfservice/getCurrentCart"].mergedIds) {
                clonedCart.mergedIds = [...this.$store.getters["selfservice/getCurrentCart"].mergedIds];
                // CRITICAL [v22]: Ana masanın haritada görünür kalması için isMerged FALSE olmalıdır.
                clonedCart.isMerged = false;
            }
            clonedCart.active = true;
            clonedCart.isFullTable = true;
            this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
            const branchId = this.$store.state.AppActiveUser.branch.id;
            clonedCart.branchId = branchId;
            const saveRes = await setBranchCart({ 
              value: clonedCart, 
              tableId: clonedCart.tableId,
              branchTableUId: clonedCart.branchTableUId // UUID bazlı seans koruması
            });

            // CRITICAL [v21]: Birleşmiş masalar için Geliştirilmiş Ping Lojiği
            if (clonedCart.mergedIds && clonedCart.mergedIds.length > 0) {
                const allCarts = this.$store.getters["selfservice/getCarts"];
                for (const mId of clonedCart.mergedIds) {
                    try {
                        let existingMCart = allCarts.find(c => c && c.tableId === mId);
                        let mValue = existingMCart ? JSON.parse(JSON.stringify(existingMCart)) : { tableId: mId };

                        mValue.branchId = branchId;
                        mValue.isFullTable = true;
                        mValue.active = true;
                        mValue.isMerged = true;
                        mValue.mergedIds = [...clonedCart.mergedIds];

                        await setBranchCart({ value: mValue, tableId: mId, branchTableUId: (clonedCart ? clonedCart.branchTableUId : null) });
                    } catch (mErr) {
                        console.error("Secondary table safe ping error (doPay v21):", mErr);
                    }
                }
            }



            if (saveRes && saveRes.data && saveRes.data.rowVersion) {
                clonedCart.rowVersion = saveRes.data.rowVersion;
                this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
            }
            
            this.$nextTick(() => {
              this.isTransaction = false; // POS işlemi bittiğinde ve reaktif döngü bittiğinde bayrağı indir
              
              if (this.totalPrice == 0 && this.isActive == true && !this.isLoading) {
                if (this.currentCart.cartEntries && this.currentCart.cartEntries.length > 0) {
                  this.isCommitable = true;
                  this.createCommitModel();
                }
              }
            });
          } else {
            this.$fire({
              title: "İptal",
              text: "Ödeme iptal edildi",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: data.message,
              text: "",
            });
            this.isTransaction = false;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.isTransaction = false;
          console.error("POS API Error:", err);
          this.$vs.notify({
            color: "danger",
            title: "Bağlantı Hatası",
            text: "POS cihazına bağlanılamadı.",
          });
        });
    },
    getPaymentMethodIdFromPosResponse(resultData, defaultId) {
      let posStatusId = defaultId;
      if (resultData && resultData.addedPayments && Array.isArray(resultData.addedPayments)) {
        let successfulPayments = resultData.addedPayments.filter(p => p.statusId === 2);
        if (successfulPayments.length > 0) {
          let addedPayment = successfulPayments[successfulPayments.length - 1];
          let paymentTypeId = addedPayment.paymentTypeId;
          let mediatorId = addedPayment.paymentMediatorId;
          
          if (paymentTypeId) {
            posStatusId = paymentTypeId;
          }
          
          if (addedPayment.isExternal) {
            let targetMethodName = "";
            
            // Standard PAVO Mediator ID / PaymentType ID mappings for External Payments:
            // 1/101 = Multinet
            // 2/102 = Sodexo
            // 3/103/13/26/113/126 = Ticket (Edenred / Ticket Gift)
            // 4/104 = Setcard
            // 5/105 = Metropol
            // 6/106 = TokenFlex
            if (mediatorId === 1 || mediatorId === 101 || paymentTypeId === 1 || paymentTypeId === 101) {
              targetMethodName = "Multinet";
            } else if (mediatorId === 2 || mediatorId === 102 || paymentTypeId === 2 || paymentTypeId === 102) {
              targetMethodName = "Sodexo";
            } else if (
              mediatorId === 3 || mediatorId === 103 || mediatorId === 13 || mediatorId === 26 || mediatorId === 113 || mediatorId === 126 ||
              paymentTypeId === 3 || paymentTypeId === 103 || paymentTypeId === 13 || paymentTypeId === 26 || paymentTypeId === 113 || paymentTypeId === 126
            ) {
              targetMethodName = "Ticket";
            } else if (mediatorId === 4 || mediatorId === 104 || paymentTypeId === 4 || paymentTypeId === 104) {
              targetMethodName = "Setcard";
            } else if (mediatorId === 5 || mediatorId === 105 || paymentTypeId === 5 || paymentTypeId === 105) {
              targetMethodName = "Metropol";
            } else if (mediatorId === 6 || mediatorId === 106 || paymentTypeId === 6 || paymentTypeId === 106) {
              targetMethodName = "TokenFlex";
            }
            
            if (targetMethodName) {
              let matchingMethod = this.paymentMethods.find(m => 
                (m.Name && m.Name.toLowerCase().includes(targetMethodName.toLowerCase())) ||
                (m.name && m.name.toLowerCase().includes(targetMethodName.toLowerCase()))
              );
              if (matchingMethod) {
                posStatusId = matchingMethod.id;
              }
            }
          }
        }
      }
      return posStatusId;
    },


    reCalculatePaymentGroup: function () {
      this.paymentGroups.forEach((pgroup) => {
        let totalPrice = 0;
        pgroup.entries.forEach((entry) => {
          totalPrice += Math.round(entry.price * 100) / 100;
        });
        pgroup.totalPrice = Math.round(totalPrice * 100) / 100;
      });

      // Cart'ın toplam fiyatını da güncelle (Safe for Vuex)
      const currentCart = _.cloneDeep(this.$store.getters["selfservice/getCurrentCart"]);
      if (currentCart && currentCart.cartEntries) {
        let cartTotal = 0;
        currentCart.cartEntries.forEach(cartEntry => {
          cartTotal += cartEntry.price || 0;
        });
        currentCart.totalPrice = Math.round(cartTotal * 100) / 100;
        this.$store.dispatch('selfservice/updateCartsById', [currentCart]);
      }
    },

    doPayGmp: async function (payedPrice, isDiscount) {
      if (this.isTransaction && !isDiscount) return;
      this.isTransaction = true; // GMP ödemesi sırasında popup kapanmasın

      if (this.isPosConnectionError && !isDiscount && this.selectedPaymentMethod && 
          (this.selectedPaymentMethod.id == this.VUE_APP_CASH_PAYMENT_ID || this.selectedPaymentMethod.id == this.VUE_APP_CREDIT_PAYMENT_ID)) {
        this.$vs.notify({
          color: "danger",
          title: "Bağlantı Hatası",
          text: "POS Bridge bağlantısı olmadığı için ödeme yapılamaz!",
        });
        this.isTransaction = false;
        return;
      }

      // Seçilen gruplarda çalışan süreli ürün varsa ödeme yapılamaz
      if (this.hasRunningTimeProducts) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Seçilen ürünlerde çalışan süreli ürünler var. Önce onları durdurunuz!",
        });
        this.isTransaction = false;
        return;
      }

      if (this.selectedPaymentGroup.length == 0) {

        this.selectedPaymentGroup = this.paymentGroups;

      }

      let posSaleItems = [];
      this.selectedPaymentGroup.forEach(function (selectProduct) {
        if (selectProduct.payedPrice != selectProduct.totalPrice) {
          let priceToPay = selectProduct.totalPrice - selectProduct.payedPrice;
          if (selectProduct.entries.length == 1) {
            posSaleItems.push({
              name: selectProduct.entries[0].productName,
              quantity: selectProduct.entries[0].quantity,
              kdv: selectProduct.entries[0].kdv,
              price: Math.round(priceToPay * 1000) / 1000,
            });
          } else {
            let groupRemaining = selectProduct.totalPrice - selectProduct.payedPrice;
            let groupDistributed = 0;
            selectProduct.entries.forEach((entry, eIdx) => {
              let entryRemaining = entry.price;
              let eRatio = groupRemaining > 0 ? (entryRemaining / selectProduct.totalPrice) : 0;
              let eChunk = (eIdx === selectProduct.entries.length - 1)
                ? Math.round((priceToPay - groupDistributed) * 100) / 100
                : Math.round((priceToPay * eRatio) * 100) / 100;
              posSaleItems.push({
                name: entry.productName,
                quantity: entry.quantity,
                kdv: entry.kdv,
                price: Math.round(eChunk * 1000) / 1000,
              });
              groupDistributed += eChunk;
            });
          }
        }
      });

      this.isLoading = true;

      if (isDiscount) {
        this.isLoading = false;
        // Deep clone paymentGroups so modifications don't mutate Vuex
        if (this.selectedPaymentGroup.length == 0) {
          this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.paymentGroups));
        } else {
          // If already selected, ensure it's cloned independently
          this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.selectedPaymentGroup));
        }

        var totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
        var distributedAmount = 0;
        var payedPriceFloat = parseFloat(payedPrice);

        this.selectedPaymentGroup.forEach((group, index) => {
          var remaining = group.totalPrice - group.payedPrice;
          var pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
          
          var chunk = 0;
          if (index === this.selectedPaymentGroup.length - 1) {
            chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
          } else {
            chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
          }
          
          group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
          if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
          distributedAmount += chunk;

          if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
            group.status = "Ödendi";
          }
        });

        // Merge selected modifications back into the global paymentGroups list
        this.selectedPaymentGroup.forEach((modifiedGroup) => {
           let idx = this.paymentGroups.findIndex(pg => pg.rowIndex === modifiedGroup.rowIndex);
           if (idx !== -1) {
             // Mutating our local list (which is cloned inside initValues, thus safe from Vuex)
             this.$set(this.paymentGroups, idx, modifiedGroup);
           }
        });

        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
          this.selectedPaymentGroup
        );
        this.selectedPaymentGroup = [];
        this.reCalculatePaymentGroup();

        let orderPayment = {
          id: uuid.v1(),
          paymentMethod: this.selectedPaymentMethod,
          price: payedPrice,
          value: isDiscount ? this.paymentDiscount.value : null,
          unit: isDiscount ? this.paymentDiscount.unit : null,
          description: isDiscount ? this.paymentDiscount.description : null,
        };
        this.orderPayments.push(orderPayment);
        // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
        this.toggleCalc = false;
        this.isTransaction = false;
      } else {

        // var token = localStorage.getItem("auth-token");

        fetch(process.env.VUE_APP_POS_API + "create", {

          method: "POST",

          headers: {

            Accept: "application/json",

            "Content-Type": "application/json",

          },

          body: JSON.stringify({

            PaymentType:

              this.selectedPaymentMethod.id ==

              process.env.VUE_APP_CREDIT_PAYMENT_ID

                ? 4

                : 1,

            SaleItems: posSaleItems,

          }),

        })

          .then((response) => response.json())

          .then(async (data) => {

            this.isLoading = false;

            if (data.statusCode == 200) {
              // Deep clone paymentGroups so modifications don't mutate Vuex
              if (this.selectedPaymentGroup.length == 0) {
                this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.paymentGroups));
              } else {
                // If already selected, ensure it's cloned independently
                this.selectedPaymentGroup = JSON.parse(JSON.stringify(this.selectedPaymentGroup));
              }

              // Oransal Dağıtım Mantığı (Merge yerini alıyor)
              let totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
              let distributedAmount = 0;
              let payedPriceFloat = parseFloat(payedPrice);

              this.selectedPaymentGroup.forEach((group, index) => {
                let remaining = group.totalPrice - group.payedPrice;
                let pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
                
                let chunk = 0;
                if (index === this.selectedPaymentGroup.length - 1) {
                  // Son kalem kuruş farklarını alır
                  chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
                } else {
                  chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
                }
                
                group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
                if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
                
                distributedAmount += chunk;

                // Eğer tamamen ödendiyse durumunu güncelle
                if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
                  group.status = "Ödendi";
                }
              });

              // Merge selected modifications back into the global paymentGroups list
              this.selectedPaymentGroup.forEach((modifiedGroup) => {
                 let idx = this.paymentGroups.findIndex(pg => pg.rowIndex === modifiedGroup.rowIndex);
                 if (idx !== -1) {
                   // Mutating our local list (which is cloned inside initValues, thus safe from Vuex)
                   this.$set(this.paymentGroups, idx, modifiedGroup);
                 }
              });

              this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
                this.selectedPaymentGroup
              );
              this.selectedPaymentGroup = [];

              this.reCalculatePaymentGroup();



              let orderPayment = {

                id: uuid.v1(),

                paymentMethod: this.selectedPaymentMethod,

                price: payedPrice,

                value: isDiscount ? this.paymentDiscount.value : null,

                unit: isDiscount ? this.paymentDiscount.unit : null,

                description: isDiscount

                  ? this.paymentDiscount.description

                  : null,

              };

              // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine

              this.orderPayments.push(orderPayment);
              this.toggleCalc = false;

              // POS ödemesi başarılı, sunucuyu ve sepeti güncelle
              let clonedCart = Object.assign({}, this.$store.getters["selfservice/getCurrentCart"]);
              clonedCart.paymentGroups = JSON.parse(JSON.stringify(this.paymentGroups));
              clonedCart.totalPayedPrice = Math.round((clonedCart.totalPayedPrice + payedPrice) * 100) / 100;
              clonedCart.orderPayments = JSON.parse(JSON.stringify(this.orderPayments));

              // CRITICAL: Birleşmiş masa bilgisini (mergedIds) her zaman koru
              if (this.localMergedIds && this.localMergedIds.length > 0) {
                  clonedCart.mergedIds = [...this.localMergedIds];
                  clonedCart.isMerged = true;
              } else if (this.$store.getters["selfservice/getCurrentCart"].mergedIds) {
                  clonedCart.mergedIds = [...this.$store.getters["selfservice/getCurrentCart"].mergedIds];
                  clonedCart.isMerged = !!(clonedCart.mergedIds.length > 0);
              }
              this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
              await setBranchCart({ value: clonedCart, tableId: clonedCart.tableId, branchTableUId: clonedCart.branchTableUId });
              
              this.$nextTick(() => {
                this.isTransaction = false; // GMP işlemi bittiğinde ve reaktif döngü bittiğinde bayrağı indir
                
                if (this.totalPrice == 0 && this.isActive == true && !this.isLoading) {
                  if (this.currentCart.cartEntries && this.currentCart.cartEntries.length > 0) {
                    this.isCommitable = true;
                    this.createCommitModel();
                  }
                }
              });

            } else {

              this.$fire({

                title: data.message,

                text: "",

                type: "error",

              });

              this.$vs.notify({

                color: "danger",

                title: data.message,

                text: "",

              });

              this.isTransaction = false;

            }

          })

          .catch(() => {

            this.isLoading = false;

            this.isTransaction = false;

            this.$fire({

              title: "Hata !",

              text: "İstek başarısız oldu. Tekrar Deneyiniz.",

              type: "error",

            });

            this.$vs.notify({

              color: "danger",

              title: "İstek başarısız oldu. Tekrar Deneyiniz.",

              text: "",

            });

          });

      }

    },

    calculateTotalOriginPrice: function (selectedGroups) {
      if (!selectedGroups) return 0;
      var selectedPrice = 0;
      selectedGroups.forEach((item) => {
        item.entries.forEach((entry) => {
          let price = Math.max(parseFloat(entry.originPrice || 0), parseFloat(entry.price || 0));

          // v138.5: Süresi devam eden ürünler için canlı fiyatı toplam orjinal fiyata ekle
          if (entry.isTime && entry.isRunning && entry.hourPrice) {
            const totalMs = this.getSafeTotalMs(entry);
            const totalMinutes = totalMs / (1000 * 60);
            const livePrice = Math.ceil(totalMinutes) * (entry.hourPrice / 60);
            if (livePrice > price) price = livePrice;
          }

          selectedPrice += price;
        });
      });
      return Math.round(selectedPrice * 100) / 100;
    },

    commitPay(payedPrice, isDiscount) {

      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }

      // Oransal Dağıtım Mantığı (Merge yerini alıyor)
      let totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
      let distributedAmount = 0;
      let payedPriceFloat = parseFloat(payedPrice);

      this.selectedPaymentGroup.forEach((group, index) => {
        let remaining = group.totalPrice - group.payedPrice;
        let pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
        
        let chunk = 0;
        if (index === this.selectedPaymentGroup.length - 1) {
          // Son kalem kuruş farklarını alır
          chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
        } else {
          chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
        }
        
        group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
        if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
        
        distributedAmount += chunk;

        // Eğer tamamen ödendiyse durumunu güncelle
        if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
          group.status = "Ödendi";
        }
      });

      this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
        this.selectedPaymentGroup
      );
      this.selectedPaymentGroup = [];

      this.reCalculatePaymentGroup();

      let orderPayment = {

        id: uuid.v1(),

        paymentMethod: this.selectedPaymentMethod,

        price: payedPrice,

        value: isDiscount ? this.paymentDiscount.value : null,

        unit: isDiscount ? this.paymentDiscount.unit : null,

        description: isDiscount ? this.paymentDiscount.description : null,

      };

      this.orderPayments.push(orderPayment);

      this.toggleCalc = false;

      this.$vs.notify({

        color: "success",

        title: "Tebrikler",

        text: payedPrice + " TL Değerinde Ödeme Gerçekleşti.",

      });

    },

    openQrReader(amount, isDiscount) {

      this.$refs.qrReader.isActive = true;

      this.$refs.qrReader.isWallet = true;

      this.$refs.qrReader.amount = amount.toFixed(2);

      this.$refs.qrReader.isDiscount = isDiscount;

    },

    calculateSelectedRemainingPrice: function (selectedGroups) {
      if (!selectedGroups) return 0;
      var selectedPrice = 0;
      selectedGroups.forEach((item) => {
        // v138.5: Süresi devam eden ürünler için canlı fiyatı hesapla
        let liveGroupTotal = 0;
        if (item.entries && item.entries.some(e => e.isTime && e.isRunning)) {
           liveGroupTotal = Math.max(0, this.calculateCurrentPrice(item) + (item.payedPrice || 0));
        } else {
           liveGroupTotal = (item.totalPrice || 0);
        }

        selectedPrice += (liveGroupTotal || 0) - (item.payedPrice || 0);
      });
      return Math.round(selectedPrice * 100) / 100;
    },

    closeCalculatorPage() {
      this.toggleCalc = false;
    },

    handleCariSelected(cari) {

      this.selectedCari = cari;

      // Cari seçildikten sonra ödeme işlemini başlat

      if (this.isPosEnabled) {

        this.doPay(

          this.selectedPaymentGroup.length > 0

            ? this.selectedGroupsPrice

            : this.totalPrice,

          false

        );

      } else {

        this.doPayWithoutPos(

          this.selectedPaymentGroup.length > 0

            ? this.selectedGroupsPrice

            : this.totalPrice,

          false

        );

      }

    },

    formatDateTimeLocal(date) {
      if (!date) return '';
      const d = new Date(date);
      if (isNaN(d.getTime())) return '';
      const pad = (num) => String(num).padStart(2, '0');
      const year = d.getFullYear();
      const month = pad(d.getMonth() + 1);
      const day = pad(d.getDate());
      const hours = pad(d.getHours());
      const minutes = pad(d.getMinutes());
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },

    getDisplayStartTime(paymentGroup) {
      if (!paymentGroup) return '';
      const entry = paymentGroup.entries.find(e => e.isTime);
      if (!entry) return '';
      const start = entry.lastStartTime || entry.createdDate;
      const startDate = this.parseSafeDate(start);
      return startDate.toLocaleString('tr-TR');
    },

    getMinStopTime(paymentGroup) {
      if (!paymentGroup) return '';
      const entry = paymentGroup.entries.find(e => e.isTime);
      if (!entry) return '';
      const start = entry.lastStartTime || entry.createdDate;
      const startDate = this.parseSafeDate(start);
      return this.formatDateTimeLocal(startDate);
    },

    openPicker(refName) {
      try {
        if (this.$refs[refName]) {
          this.$refs[refName].showPicker();
        }
      } catch (e) {
        console.error("showPicker not supported", e);
      }
    },

    openStopTimeEditPopup(paymentGroup) {
      if (!this.$isAdmin()) return;
      const entry = paymentGroup.entries.find(e => e.isTime && e.isRunning);
      if (!entry) return;

      this.selectedPaymentGroupForTimeEdit = paymentGroup;
      
      const now = new Date();
      this.customStopTime = this.formatDateTimeLocal(now);
      this.maxStopTime = this.formatDateTimeLocal(now);
      
      const start = entry.lastStartTime || entry.createdDate;
      const startDate = this.parseSafeDate(start);
      this.customStartTime = this.formatDateTimeLocal(startDate);
      this.minStopTime = this.formatDateTimeLocal(startDate);
      
      this.stopTimeEditPopupActive = true;
    },

    async saveAndStopTimer() {
      if (!this.selectedPaymentGroupForTimeEdit || !this.customStopTime || !this.customStartTime) return;

      const entry = this.selectedPaymentGroupForTimeEdit.entries.find(e => e.isTime && e.isRunning);
      if (!entry) return;

      const selectedStopDate = new Date(this.customStopTime);
      const selectedStartDate = new Date(this.customStartTime);
      const originalStart = entry.lastStartTime || entry.createdDate;
      const originalStartDate = this.parseSafeDate(originalStart);
      const now = new Date();

      // 1. Başlangıç zamanı limit kontrolü (max 10 saat geri çekme)
      const minAllowedStart = new Date(originalStartDate.getTime() - 10 * 60 * 60 * 1000);
      if (selectedStartDate < minAllowedStart) {
        this.$vs.notify({
          title: "Hata",
          text: "Başlangıç zamanı en fazla 10 saat geriye çekilebilir.",
          color: "danger"
        });
        return;
      }

      // 2. Gelecek zaman kontrolü
      if (selectedStartDate > now || selectedStopDate > now) {
        this.$vs.notify({
          title: "Hata",
          text: "Tarihler gelecek bir zaman olamaz.",
          color: "danger"
        });
        return;
      }

      // 3. Başlangıç ve bitiş zamanı aynı olamaz
      if (selectedStartDate.getTime() === selectedStopDate.getTime()) {
        this.$vs.notify({
          title: "Hata",
          text: "Başlangıç ve durdurma zamanı aynı olamaz.",
          color: "danger"
        });
        return;
      }

      // 4. Başlangıç zamanı durdurma zamanından sonra olamaz
      if (selectedStartDate > selectedStopDate) {
        this.$vs.notify({
          title: "Hata",
          text: "Başlangıç zamanı durdurma zamanından sonra olamaz.",
          color: "danger"
        });
        return;
      }

      this.stopTimeEditPopupActive = false;
      await this.stopTimeProduct(this.selectedPaymentGroupForTimeEdit, selectedStopDate, selectedStartDate);
    },

    openPriceEditDialog(paymentGroup) {

      // Only admin users can edit prices

      if (!this.$isAdmin() || (paymentGroup.totalPrice - paymentGroup.payedPrice === 0)) {

        return;

      }



      this.selectedPaymentGroupForEdit = paymentGroup;

      this.newPrice = (paymentGroup.totalPrice - paymentGroup.payedPrice).toFixed(2);

      this.priceEditPopupActive = true;

    },

    updatePrice() {

      if (!this.selectedPaymentGroupForEdit || !this.newPrice) return;



      const newPriceValue = parseFloat(this.newPrice);

      if (isNaN(newPriceValue) || newPriceValue < 0) {

        this.$vs.notify({

          title: "Hata",

          text: "Geçerli bir fiyat giriniz",

          color: "danger"

        });

        return;

      }



      // Calculate remaining price and the new total price

      const remainingPrice = this.selectedPaymentGroupForEdit.totalPrice - this.selectedPaymentGroupForEdit.payedPrice;

      const newTotalPrice = newPriceValue + this.selectedPaymentGroupForEdit.payedPrice;



      console.log("Fiyat Güncelleme:", {

        eski_kalan_fiyat: remainingPrice,

        yeni_kalan_fiyat: newPriceValue,

        eski_toplam_fiyat: this.selectedPaymentGroupForEdit.totalPrice,

        yeni_toplam_fiyat: newTotalPrice,

        odenen_miktar: this.selectedPaymentGroupForEdit.payedPrice

      });



      // Update price in cart entries and directly modify the cart

      // 1. Deep clone the entire cart to avoid direct Vuex mutations
      const currentCart = _.cloneDeep(this.$store.getters["selfservice/getCurrentCart"]);
      if (!currentCart) return;

      const entries = this.selectedPaymentGroupForEdit.entries;

      if (entries.length === 1) {
        // If there's only one entry, update its price directly
        const entry = entries[0];
        const cartEntry = currentCart.cartEntries.find(item =>
          item.id === entry.id ||
          (item.productId === entry.productId && item.variantId === entry.variantId)
        );

        if (cartEntry) {
          const diff = newTotalPrice - entry.price;
          entry.originPrice += diff;
          entry.price = newTotalPrice;
          
          cartEntry.originPrice += diff;
          cartEntry.price = newTotalPrice;

          if (entry.quantity > 1) {
            cartEntry.unitPrice = newTotalPrice / entry.quantity;
            entry.unitPrice = newTotalPrice / entry.quantity;
          }
        }
      } else {
        // If multiple entries, distribute price proportionally
        const totalOriginalPrice = entries.reduce((sum, e) => sum + e.price, 0);

        entries.forEach(entry => {
          const priceRatio = totalOriginalPrice > 0 ? (entry.price / totalOriginalPrice) : 0;
          const newEntryPrice = newTotalPrice * priceRatio;

          const cartEntry = currentCart.cartEntries.find(item =>
            item.id === entry.id ||
            (item.productId === entry.productId && item.variantId === entry.variantId)
          );

          if (cartEntry) {
            const diff = newEntryPrice - entry.price;
            entry.originPrice += diff;
            entry.price = newEntryPrice;
            
            cartEntry.originPrice += diff;
            cartEntry.price = newEntryPrice;
          }
        });
      }

      // Update local payment group total (safe as it's cloned)
      this.selectedPaymentGroupForEdit.totalPrice = newTotalPrice;

      // Recalculate cart's total price on the clone
      currentCart.totalPrice = currentCart.cartEntries.reduce((total, e) => total + e.price, 0);

      // Save changes to cart via store
      this.$store.dispatch('selfservice/updateCartsById', [currentCart]);

      // Save to backend
      setBranchCart({ 
        value: currentCart, 
        tableId: currentCart.tableId,
        branchTableUId: currentCart.branchTableUId // UUID bazlı birincil anahtar
      }).then((res) => {
        // CRITICAL [v25]: RowVersion sync after price edit
        if (res && res.data && res.data.rowVersion) {
          currentCart.rowVersion = res.data.rowVersion;
          this.$store.dispatch('selfservice/updateCartsById', [currentCart]);
        }
        
        this.$vs.notify({
          title: "Başarılı",
          text: "Fiyat başarıyla güncellendi",
          color: "success"
        });

        this.reCalculatePaymentGroup();
        this.priceEditPopupActive = false;
      }).catch(error => {
        console.error("Fiyat güncellenirken hata oluştu:", error);
        this.$vs.notify({
          title: "Hata",
          text: "Fiyat güncellenirken bir hata oluştu",
          color: "danger"
        });
      });



      // Update payment group total price

      this.selectedPaymentGroupForEdit.totalPrice = newTotalPrice;



      // Recalculate cart's total price

      currentCart.totalPrice = currentCart.cartEntries.reduce((total, entry) => total + entry.price, 0);



      // Save changes to cart

      setBranchCart({ 
        value: currentCart, 
        tableId: currentCart.tableId,
        branchTableUId: currentCart.branchTableUId // UUID bazlı seans koruması
      }).then((res) => {
        // CRITICAL [v25]: RowVersion sync after price edit
        if (res && res.data && res.data.rowVersion) {
          currentCart.rowVersion = res.data.rowVersion;
          this.$store.dispatch('selfservice/updateCartsById', [currentCart]);
        }

        this.$vs.notify({

          title: "Başarılı",

          text: "Fiyat başarıyla güncellendi",

          color: "success"

        });



        // Recalculate totals

        this.reCalculatePaymentGroup();



        // Close popup

        this.priceEditPopupActive = false;

      }).catch(error => {

        console.error("Fiyat güncellenirken hata oluştu:", error);

        this.$vs.notify({

          title: "Hata",

          text: "Fiyat güncellenirken bir hata oluştu",

          color: "danger"

        });

      });

    },

    // Telefon kilidi açıldığında sepetleri yeniden yükle

    handleVisibilityChange() {

      // Sayfa görünür hale geldiğinde ve component aktifse sepetleri yeniden yükle

      if (!document.hidden && this.isActive) {

        this.refreshCarts();

      }

    },

    async refreshCarts() {
      if (this.isTimerActionInProgress) {
        console.log("[TimerGuard-Mobile] refreshCarts bypassed while timer action in progress.");
        return;
      }
      try {

        let carts = await getCarts();

        const parsedCarts = carts.data;

        if (parsedCarts.length > 0) {

          const currentCart = this.$store.getters["selfservice/getCurrentCart"];

          this.$store.dispatch(

            "selfservice/setToCart",

            parsedCarts.map((cart) => ({

              ...cart,

              active: cart.tableId === currentCart.tableId,

            }))

          );



          // Mevcut sepeti güncelle

          const updatedCurrentCart = parsedCarts.find(cart => cart.tableId === currentCart.tableId);

          if (updatedCurrentCart) {

            this.changeCart(updatedCurrentCart);

          }

        }

      } catch (error) {

        console.error("Sepetler yenilenirken hata oluştu:", error);

      }

    },

  },

  created() {
    const savedCopyCount = localStorage.getItem("printCopyCount");
    if (savedCopyCount) {
      this.printCopyCount = parseInt(savedCopyCount);
    }

    const savedPrintPreference = localStorage.getItem("isPrintOrders");
    if (savedPrintPreference !== null) {
      this.isPrintOrders = savedPrintPreference === "true";
    }

    this.checkPosDevice();


    this.checkScreen();

    window.addEventListener("resize", this.checkScreen);

    window.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.timerInterval = setInterval(() => {
        this.currentTime = new Date();
    }, 30000); // 30 saniyede bir fiyatları tazele
  },

  beforeDestroy() {
    this.stopPosConnectionTimer();

    window.removeEventListener("resize", this.checkScreen);

    window.removeEventListener("visibilitychange", this.handleVisibilityChange);
    if (this.timerInterval) clearInterval(this.timerInterval);
  },

  mounted() {

    if(this.isActive && this.totalPrice == 0){

      this.isCommitable = true;

    }

  },

};

</script>



<style>

.mobile-payment-screen {

  position: fixed;

  top: 0;

  left: 0;

  width: 100%;

  height: 100%;

  height: 100dvh; 

  min-height: -webkit-fill-available; 

  background-color: #f9f5f5;

  z-index: 9999;

  display: flex;

  flex-direction: column;

  overflow: hidden;

}



/* Header */

.payment-header {

  display: flex;

  justify-content: space-between;

  align-items: center;

  background-color: rgb(106, 31, 19);

  color: white;

  padding: 0.75rem 1rem;

}



.header-title {

  display: flex;

  align-items: center;

  font-size: 1.25rem;

  font-weight: 600;

}



.header-title i {

  margin-right: 0.75rem;

  font-size: 1.5rem;

}



.close-button {

  background: transparent;

  border: none;

  color: white;

  font-size: 1.25rem;

  height: 2rem;

  width: 2rem;

  display: flex;

  align-items: center;

  justify-content: center;

  cursor: pointer;

}



/* Personal Info */

.personal-info {

  display: flex;

  justify-content: space-between;

  padding: 0.5rem 1rem;

  background-color: #f9f5f5;

  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  font-size: 0.875rem;

}



.info-label {

  font-weight: 600;

  color: rgb(106, 31, 19);

}



.info-value {

  color: rgb(106, 31, 19);

  font-weight: 500;

}



.ml-1 {

  margin-left: 0.25rem;

}



/* Products List */

.products-container {

  flex: 1;

  min-height: 0; /* Webkit browser scroll fix */

  overflow-y: auto;

  -webkit-overflow-scrolling: touch; /* iOS inertial scroll */

  background-color: white;

}



.products-list {

  overflow-x: hidden;

  width: 100%;

}



.products-table {

  width: 100%;

  border-collapse: collapse;

}



.products-table th {

  position: sticky;

  top: 0;

  background-color: #ffffff;

  color: #543633;

  font-weight: 600;

  padding: 0.75rem 1rem;

  text-align: left;

  font-size: 0.9rem;

}



.products-table td {

  padding: 0.75rem 1rem;

  border-bottom: 1px solid #f3f4f6;

}



.selectable-row {

  cursor: pointer;

  transition: background-color 0.2s;

}



.selected-row {

  background-color: #c6efce !important;

  border-left: 5px solid #006100 !important;

  font-weight: bold;

}



.selected-row .product-name, 

.selected-row .price-display,

.selected-row .product-extra,

.selected-row .product-rawmaterial {

  color: #006100 !important;

}



.alternate-row {

  background-color: rgba(0, 0, 0, 0.02);

}



.product-col {

  width: 50%;

}

.time-col {

  width: 25%;

  text-align: center;

}



.price-col {

  width: 25%;

  text-align: right;

}



.product-entry {

  margin-bottom: 0.375rem;

}



.product-name {

  font-weight: 600;

  font-size: 0.9rem;

  color: rgb(106, 31, 19);

  margin-bottom: 0.125rem;

}



.product-rawmaterial {

  font-size: 0.8rem;

  color: rgb(106, 31, 19);

  font-style: italic;

  opacity: 0.8;

}



.mobile-extras {

  display: flex;

  flex-direction: column;

  margin-top: 0.25rem;

}



.product-extra {

  color: rgb(106, 31, 19);

  font-size: 0.8rem;

  opacity: 0.8;

  margin-left: 0.5rem;

}



.gift-icon {

  color: rgb(130, 223, 130);

  margin-right: 0.25rem;

  font-size: 1rem;

}



.price-display {

  display: flex;

  flex-direction: column;

  align-items: flex-end;

}



.original-price {

  text-decoration: line-through;

  color: rgb(106, 31, 19);

  opacity: 0.7;

  font-size: 0.8rem;

}



.current-price {

  font-weight: 600;

  color: rgb(106, 31, 19);

  font-size: 0.95rem;

}



.paid-price {

  color: rgb(130, 223, 130);

  font-weight: 700;

}



.clickable-price {

  cursor: pointer;

  transition: all 0.3s;

  position: relative;

}



.clickable-price:hover {

  color: #007bff !important;

  transform: scale(1.05);

}



.clickable-price:after {

  content: "✏️";

  font-size: 12px;

  position: absolute;

  top: -5px;

  right: -5px;

  opacity: 0;

  transition: opacity 0.3s;

}



.clickable-price:hover:after {

  opacity: 1;

}



/* Total Bar */

.total-bar {

  background-color: #ffd1d1;

  padding: 0.75rem 1rem;

  display: flex;

  justify-content: space-between;

  align-items: center;

}



.total-section, .selected-section {

  display: flex;

  align-items: center;

}



.total-label {

  font-weight: 600;

  margin-right: 0.5rem;

  font-size: 0.95rem;

  color: #543633;

}



.total-price {

  font-weight: 700;

  font-size: 1.1rem;

  color: #543633;

}



.history-button {

  background: transparent;

  border: none;

  margin-left: 0.5rem;

  color: #543633;

  cursor: pointer;

  padding: 0.25rem;

  display: flex;

  align-items: center;

  justify-content: center;

}



/* Print Option */

.print-option {

  display: flex;

  align-items: center;

  justify-content: space-between;

  padding: 0.5rem 1rem;

  background-color: white;

  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

}



.checkbox-label {

  display: flex;

  align-items: center;

  font-size: 0.9rem;

  color: rgb(106, 31, 19);

  font-weight: 600;

}



.checkbox-label input {

  margin-right: 0.5rem;

}



.print-button {

  display: flex;

  align-items: center;

  background-color: rgb(106, 31, 19);

  color: white;

  border: none;

  border-radius: 4px;

  padding: 0.5rem 1rem;

  font-size: 0.9rem;

  font-weight: 600;

  cursor: pointer;

}



.print-button i {

  margin-right: 0.5rem;

}



/* Payment History */

.payment-history {

  background-color: #ffd1d1;

  margin: 0;

  padding: 0;

  max-height: 10rem;

  overflow-y: auto;

}



.payment-log {

  padding: 0.5rem 1rem;

  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  font-weight: 600;

  color: #543633;

  font-size: 0.9rem;

}



/* Payment Sticky Bottom Footer Area (v118.V29) */
.sticky-payment-footer {
  flex-shrink: 0;
  background-color: #f9f5f5;
  border-top: 2px solid rgba(106, 31, 19, 0.1);
  box-shadow: 0 -4px 15px rgba(0, 0, 0, 0.1);
  z-index: 50;
  display: flex;
  flex-direction: column;
}

.payment-summary-card {
  background: white;
  margin: 10px 15px 5px 15px !important; /* Reduced margins for footer alignment */
  padding: 12px 16px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.payment-options {
  padding: 0.75rem 1rem;
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  background-color: white;
}



.payment-type-selector {

  margin-bottom: 1rem;

}



.action-buttons {

  display: grid;

  grid-template-columns: repeat(3, 1fr);

  gap: 0.5rem;

  padding: 0.25rem;

}



.action-button {

  display: flex;

  align-items: center;

  justify-content: center;

  padding: 0.75rem 0.5rem;

  border-radius: 0.375rem;

  border: none;

  font-weight: 600;

  font-size: 0.875rem;

  cursor: pointer;

  transition: background-color 0.2s;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

}



.action-button i {

  margin-right: 0.5rem;

}



.action-button:disabled {

  opacity: 0.6;

  cursor: not-allowed;

}



.clear-button {

  background-color: #ff5252;

  color: white;

}



.split-button {

  background-color: #ff9800;

  color: white;

}



.amount-split-button {

  background-color: #673ab7; /* Deep Purple/Indigo for distinctive action */

  color: white;

}



.pay-button {

  background-color: rgb(130, 223, 130);

  color: white;

}



.complete-button {

  background-color: #4CAF50;

  color: white;

  animation: pulse 2s infinite;

}



@keyframes pulse {

  0% {

    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);

  }

  70% {

    box-shadow: 0 0 0 10px rgba(76, 175, 80, 0);

  }

  100% {

    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);

  }

}



/* Media queries for very small screens */

@media (max-width: 360px) {

  .action-buttons {

    grid-template-columns: 1fr;

  }



  .header-title {

    font-size: 1.1rem;

  }



  .header-title i {

    font-size: 1.2rem;

  }



  .total-label, .total-price {

    font-size: 0.9rem;

  }



  .product-name {

    font-size: 0.85rem;

  }



  .product-extra, .product-rawmaterial {

    font-size: 0.75rem;

  }

}



/* Loading animation */

.rotating {

  animation: rotate 1s linear infinite;

}



@keyframes rotate {

  from {

    transform: rotate(0deg);

  }

  to {

    transform: rotate(360deg);

  }

}



/* Print button disabled state */

.print-button:disabled {

  opacity: 0.7;

  cursor: not-allowed;

}



/* Discount popup styles */

.mobile-friendly-popup.vs-popup {

  max-width: 100% !important;

  width: 100% !important;

  margin: 0 !important;

  height: 100% !important;

  max-height: 100vh !important;

  top: 0 !important;

  left: 0 !important;

  border-radius: 0 !important;

  z-index: 99999 !important; /* Ensure it's above everything else */

}



/* Fix for duplicate popups */

.vs-popup:not(.vs-popup--rebound) + .vs-popup:not(.vs-popup--rebound) {

  display: none !important;

}



@media (min-width: 769px) {

  .mobile-friendly-popup.vs-popup {

    max-width: 1000px !important;

    width: auto !important;

    height: auto !important;

    border-radius: 1rem !important;

    margin: 2rem auto !important;

  }

}



.price-edit-popup {

  z-index: 100001 !important;

}



.price-edit-popup .vs-popup {

  max-width: 95vw !important;

}



.price-edit-content {

  padding: 1rem;

}



.product-name {

  margin-bottom: 1rem;

  font-size: 16px;

}



.price-field {

  margin-bottom: 1.5rem;

}



.price-field label {

  display: block;

  margin-bottom: 0.5rem;

  font-weight: 500;

}



.price-value {

  font-weight: bold;

  color: var(--primary);

}



.popup-actions {

  display: flex;

  justify-content: flex-end;

  margin-top: 1.5rem;

}



/* Merge Product Modal Styles */

#mergeProductModal .vs-popup .vs-popup--header {

  display: none !important;

}



#mergeProductModal .vs-popup .vs-popup--content {

  padding: 1.5rem !important;

  max-width: 550px !important;

  width: 90vw !important;

  max-height: 85vh !important;

}



#mergeProductModal .vs-popup {

  border-radius: 1rem !important;

}



.price-input {

  font-size: 2rem !important;

  background: #f2f2f2 0% 0% no-repeat padding-box !important;

  text-align: center !important;

  padding: 0.5rem !important;

  border: 1px solid #e1e1e1 !important;

  border-radius: 0.5rem !important;

}

/* Disabled payment button styles */
button:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background-color: #ccc !important;
}

/* Disabled time control button styles */
.time-control-buttons .vs-button:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  background-color: #ccc !important;
  color: #666 !important;
}

/* Time control styles */
.time-control-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.time-control-buttons {
  display: flex;
  justify-content: center;
}

.time-control-buttons .vs-button {
  min-width: 75px !important;
  /* width: 32px !important; */
  height: 40px !important;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.time-display {
  font-size: 0.7rem;
  color: rgb(106, 31, 19);
  font-weight: 600;
  text-align: center;
  line-height: 1;
}

/* Adjust column widths when time products are present */
.products-table:has(.time-col) .product-col {
  width: 50%;
}

.products-table:has(.time-col) .price-col {
  width: 25%;
}

.products-table:not(:has(.time-col)) .product-col {
  width: 65%;
}

.products-table:not(:has(.time-col)) .price-col {
  width: 35%;
}

.description-prompt-popup {
  z-index: 100001 !important;
}

</style>

<style>
.mobile-copy-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
}

.mobile-copy-label {
  font-size: 0.7rem;
  font-weight: bold;
  color: #6a1f13;
  margin-bottom: 2px;
}

.mobile-copy-input {
  width: 50px;
  height: 35px;
  border-radius: 8px;
  border: 1px solid #ccc;
  text-align: center;
  font-weight: bold;
  color: #6a1f13;
  background: #fff;
  outline: none;
}

.mobile-copy-input:focus {
  border-color: #6a1f13;
}

.line-through {
  text-decoration: line-through !important;
}
/* Redesigned Financial Summary Card */
.payment-summary-card {
  background: white;
  margin: 15px;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.payment-summary-card .summary-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.payment-summary-card .summary-line .label {
  font-size: 0.95rem;
  color: #666;
  font-weight: 500;
}

.payment-summary-card .summary-line .value {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.payment-summary-card .discount-line .value {
  color: #ff4757;
}

.payment-summary-card .paid-line .value {
  color: #2ed573;
}

.payment-summary-card .summary-divider {
  height: 1px;
  background: #eee;
  margin: 12px 0;
}

.payment-summary-card .total-line .label {
  font-size: 1.1rem;
  font-weight: 800;
  color: #1e1e1e;
}

.payment-summary-card .total-line .value {
  font-size: 1.4rem;
  font-weight: 900;
  color: #ea5455;
}

.payment-summary-card .selected-badge {
  background: #f1f2f6;
  padding: 6px 12px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  margin-top: 10px;
  font-size: 0.85rem;
  font-weight: 700;
  color: #2f3542;
}

.payment-summary-card .selected-badge i {
  margin-right: 6px;
  font-size: 0.9rem;
}

/* Receipt Preview Popup Styles */
.receipt-preview-popup .vs-popup--content {
  padding: 0 !important;
  background: #f5f5f5 !important;
}

.preview-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.preview-header {
  background: white;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 10;
  border-bottom: 1px solid #eee;
}

.preview-content {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  display: flex;
  justify-content: center;
  background: #f8f9fa;
}

.preview-content .pr-container {
  margin: 0 auto !important;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1) !important;
  border: 1px solid #ddd !important;
}

</style>

